// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: `Já existe um layout com esse nome`,
    ACCEPT: `Aceitar`,
    ACCEPT_ALL: `Aceitar Tudo`,
    ACCEPT_REJECT_TRANSFER_PENDING: `Aprovação Pendente`,
    ACCEPTED: `Aceito`,
    ACCOUNT: `Conta`,
    ACCOUNT_ADDRESS: `Endereço da Conta`,
    ACCOUNT_COUNTRY: `País da Conta do Concessionário`,
    ACCOUNT_END: `Fim da Conta`,
    ACCOUNT_NAME: `Nome do Concessionário`,
    ACCOUNT_NUMBER: `Número da Conta do Concessionário`,
    ACCOUNT_NUMBER_REQUIRED: `Número da Conta é necessário`,
    ACCOUNTS: `Contas`,
    ACCUMULATED_DAYS_ON_RENT: `Dias acumulados de aluguel`,
    ACCUMULATED_DAYS_RENTED: `Total de Dias alugados`,
    ACTIONS: `Ações`,
    ACTIVE_WARRANTY: `Garantia ativa`,
    ACTIVE_WARRANTY_CLICK_FOR_DETAIL: `Garantia Ativa (Clique para obter detalhes)`,
    ACTIVE_WARRANTY_Y_N: `Garantia Ativa (S/N)`,
    ACTUAL_AMOUNT_OF_USE: `Quantidade Real de Uso`,
    ACTUAL_AUDIT: `Auditoria efetiva`,
    ACTUAL_AUDIT_DATE: `Data da Auditoria Efetiva`,
    ACTUAL_COURIER_NAME: `Nome da Transportadora`,
    ACTUAL_H: `Horas Totais`,
    ACTUAL_HOURS: `Horas Totais`,
    ACTUAL_PC:`Fardos Reais`,
    ADD_CLAIM: `Adicionar reclamação`,
    ADD_CLAIMS: `Adicionar reclamações`,
    ADD_COMPONENT: `Adicionar Componente`,
    ADD_OPTION: `Adicionar opção`,
    ADD_REP: `Reparo Adicional`,
    ADD_TO_AUDIT: `Adicionar à auditoria`,
    ADDITIONAL: `Adicional`,
    ADDITIONAL_COMMENTS: `Comentários Adicionais`,
    ADDITIONAL_REPAIR: `Reparo Adicional`,
    ADDITIVE: `Aditivo`,
    ADDRESS: `Endereço`,
    ADDRESS_LINE1: `Linha de Endereço 1`,
    ADDRESS_LINE1_REQUIRED: `Linha de Endereço 1 Necessária`,
    ADDRESS_LINE2: `Linha de Endereço 2`,
    ADJ_CLM: `Ajustar Solicitação`,
    ADJUST_CLAIM: `Ajustar Solicitação`,
    ADJUSTED_HOURS: `Horas Ajustadas`,
    ADJUSTED_QUANTITY: `Quantidade Ajustada`,
    ADJUSTMENT_TYPE: `Tipo de ajuste`,
    ADVANCED_CLAIM_SUMMARY: `Avançado Resumo de Reclamação`,
    AFTER_DELIVERY_INSPECTION: `INSPEÇÃO PÓS-ENTREGA`,
    AGENCY_NAME: `Nome da Agência`,
    ALL: `Tudo`,
    ALL_ACCOUNTS: `Todas as contas`,
    ALL_CLAIMS: `Todas as reclamações`,
    ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: `Todas as reclamações estão sujeitas a revisão (consulte JD WAM 110.08 para obter mais informações)`,
    ALL_CLAIMS_TAB: `Todas as Reclamações ({count, number})`,
    ALL_PART_REQUESTS: `Solicitações de Todas as Peças`,
    ALL_PART_REQUESTS_WITH_COUNT: `Solicitações de Todas as Peças ({count})`,
    ALL_PARTS_RETURNED: `Todas Peças Devolvidas`,
    AMOUNT: `Quantidade`,
    AMOUNT_1: `Quantidade 1`,
    AMOUNT_2: `Quantidade 2`,
    AMOUNT_3: `Quantidade 3`,
    AMOUNT_OF_USE: `Quantidade de Uso`,
    AMOUNT_OF_USE_ACCEPETD: `Quantidade de Uso Aceita`,
    AMOUNT_OF_USE_CREATED_SUCCESSFULLY: `Quantidade de Uso Criada com Sucesso`,
    AMOUNT_OF_USE_HISTORY_WITH_COUNT: `Histórico da Quantidade de Uso ({count})`,
    AMOUNT_OF_USE_IS_REQUIRED: `Quantidade de Uso Obrigatório`,
    AMOUNT_OF_USE_REJECTED: `Quantidade de Uso Rejeitada`,
    AMOUNT_OF_USE_REQUESTS_STATUS: `Status de Solicitações de Quantidade de Uso`,
    AMOUNT_OF_USE_REQUESTS_WITH_COUNT: `Quantidade de Solicitações de Uso ({count})`,
    AMOUNT_OF_USE_REQUIRED: `Quantidade de Uso Obrigatório`,
    AMOUNT_OF_USE_UNITS_REQUIRED: `Quantidade de unidades de uso obrigatória`,
    AMOUNT_RECORDED: `Quantidade registrada`,
    AMOUNT_TO_BE_DEBITED: `Valor a ser debitado`,
    APLYPIP: `Aplicar o PMP`,
    APPLICATION: `Aplicação`,
    APPLICATION_IS_REQUIRED: `Aplicação é Necessária`,
    APPLY: `Aplicar`,
    APPLY_TRAVEL: `Aplicar Viagem`,
    APPROVAL_DEALER_COMMENTS: `Comentários de aprovação do concessionário`,
    APPROVAL_DETAILS: `Detalhes da aprovação`,
    APPROVAL_LELVES: `Níveis de Aprovação`,
    APPROVAL_REMARKS: `Observações de Aprovação`,
    APPROVAL_STATUS: `Status de Aprovação`,
    APPROVE: `Aprovar`,
    APPROVE_AMOUNT_OF_USE: `Aprovar Quantidade de Uso`,
    APPROVE_LABOR_RATE: `Aprovar preço de mão de obra`,
    APPROVE_MACHINE_STATUS_UPDATE: `Aprovar atualização do estado da máquina`,
    APPROVE_PIP_CODE_REQUEST: `Aprovar Pedido de Código PMP`,
    APPROVE_SPECIAL_ALLOWANCE_CLAIM: `Aprovar Solicitação de Concessão Especial`,
    APPROVED: `Aprovado`,
    APPROVED_CORE_VALUE: `Valor Principal aprovado`,
    APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: `A data de aprovação não pode ser anterior à data de configuração`,
    APPROVED_DIAGNOSTIC_AMOUNT: `Montante de Diagnóstico Aprovado`,
    APPROVED_DIAGNOSTIC_HOURS: `Horas de Diagnóstico Aprovadas`,
    APPROVED_IS_REQUIRED: `Aprovação é Necessária`,
    APPROVED_LABOR_ADDITIVE: `Aditivo de Mão de Obra aprovado`,
    APPROVED_LABOR_AMOUNT: `Quantidade de Mão de Obra aprovada`,
    APPROVED_LABOR_HOURS: `Horas de mão de obra aprovadas`,
    APPROVED_LABOR_TOTAL: `Total de Mão de Obra Aprovada`,
    APPROVED_ON_SHELF_COST: `Custo final aprovado`,
    APPROVED_OTHER_CREDITS: `Outros créditos aprovados`,
    APPROVED_PARTS: `Peças aprovadas`,
    APPROVED_PARTS_ADDITIVE: `Aditivo aprovado para Peças`,
    APPROVED_PARTS_TOTAL: `Total de peças aprovadas`,
    APPROVED_REJECTED: `Aprovado/Rejeitado`,
    APPROVED_REPAIR_AMOUNT: `Montante de Reparo Aprovado`,
    APPROVED_REPAIR_HOURS: `Horas de Reparo Aprovadas`,
    APPROVED_TAXES_TOTAL: `Total de imposto aprovado`,
    APPROVED_TRAVEL_TOTAL: `Tempo total de deslocamento aprovado`,
    APPROVER: `Aprovador`,
    ASCENDING: `Crescente`,
    ATTACHMENTS: `Acessórios`,
    AUDIT_NUMBER: `Número de Auditoria`,
    AUDIT_PLANNED: `Auditoria Planejada`,
    AUDIT_REQUIREMENT: `Requisito de auditoria`,
    AUDIT_RESULTS: `Resultados da Auditoria`,
    AUDIT_STATUS: `Status da Auditoria`,
    AUDIT_SUBMITTED_SUCCESSFULLY: `Auditoria enviada com sucesso`,
    AUDIT_SUMMARY: `Resumo da auditoria`,
    AUDIT_TYPE: `Tipo de auditoria`,
    AUDITS: `Auditorias`,
    AUDITS_DUE_WITH_COUNT: `{countToDisplay} auditoria(s) prevista(s)`,
    AUDITS_DUE_WITHIN_30_DAYS: `{countToDisplay} {count, plural, one {auditoria} other {auditoria}} prevista(s) dentro de 30 dias`,
    AUDITS_PAST_DUE_WITH_COUNT: `{countToDisplay} {count, plural, one {auditoria} other {auditoria}} vencida(s)`,
    AUTHORIZATION_NUMBER: `Número da Autorização`,
    AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: `Envio Automático do Sistema Empresarial do Concessionário`,
    AVAILABLE: `Disponível`,
    AVAILABLE_COLUMNS: `Disponível Colunas`,
    AVERAGE_DIAGNOSTICS_HOURS: `Média de horas de diagnóstico`,
    AVERAGE_LUG_HEIGHT: `Altura média do Peso`,
    AVERAGE_LUG_HEIGHT_IS_REQUIRED: `É necessária a altura média do Peso`,
    AVERAGE_REPAIR_HOURS: `Média de horas de reparação`,
    AVERAGE_REPLACEMENT_HOURS: `Média de horas de substituição`,
    AVERAGE_TECH_PAY_RATE: `Taxa Média  de Hora Técnica`,
    BACK: `Voltar`,
    BACK_TO_AUDIT: `Voltar à auditoria`,
    BASE_MACHINE: `Máquina Básica`,
    BASE_MACHINE_IMPLEMENTS: `Implementos da Máquina Base`,
    BASE_MACHINE_PIN: `PIN da Máquina Base`,
    BASIC_WARRANTY_ENDS: `A Garantia Básica Vence em`,
    BASIC_WARRANTY_ESTIMATOR: `Calculador de Garantia Básica`,
    BASIC_WARRANTY_STARTS: `Início da Garantia Básica`,
    BASIS_FOR_SETTLEMENT: `Regulamentos do Acordo`,
    BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: `Regulamentos do Acordo / Comentários de Auditoria`,
    BASIS_FOR_SETTLEMENT_IS_REQUIRED: `Regulamentos do Acordo é Necessário`,
    BATTERY: `Bateria`,
    BEGIN_DATE: `Data do Início`,
    BRANCH: `Filial`,
    BUILT: `Construído`,
    BUSINESS_END: `Fim de Negócios`,
    CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE:`A máquina pode voltar a funcionar?`,
    CANCEL: `Cancelar`,
    CERTIFIED_LETTER_SENT: `Carta Certificada Enviada`,
    CGST: `CGST`,
    CHANGE_RESPONSIBLE_DEALER: `Concessionário Responsável pela Troca`,
    CHANGE_STATUS: `Mudar status`,
    CHANGE_STATUS_FOR: `Alterar Status para {pin}`,
    CHANGED: `Alterado/Trocado`,
    CHANGED_BY: `Alterado/Trocado por`,
    CHANGED_ON: `Trocado em`,
    CHINESE: `Chinês`,
    CITY: `Cidade`,
    CITY_REQUIRED: `Cidade Necessária`,
    CLAIM: `Solicitação`,
    CLAIM_COUNT_WITH_PARENTHESIS: `({countToDisplay} {count, plural, one {solicitação} other {solicitações}})`,
    CLAIM_DEBIT: `Débito da Solicitação`,
    CLAIM_DETAILS: `Detalhes da solicitação`,
    CLAIM_DRAFT: `RASCUNHO`,
    CLAIM_HISTORY: `Histórico de Solicitações 24 mêses`,
    CLAIM_HISTORY_WITH_COUNT: `Histórico de Solicitações 24 mêses ({count})`,
    CLAIM_NUMBER: `Número da Solictação`,
    CLAIM_RECOVER_PERCENTAGE: `({percentage}%)`,
    CLAIM_SEARCH: `Pesquisa da Solicitação`,
    CLAIM_STATUS: `Status da Solicitação`,
    CLAIM_TYPE: `Tipo de Solicitação`,
    CLAIM_TYPES: `Tipos de Solicitações`,
    CLAIM_UPDATED_SUCCESSFULLY: `Solicitação Atualizada com Êxito`,
    CLAIM_VALUE: `Valor da Solicitação`,
    CLAIM_VALUE_DETAILS: `Detalhes do Valor da Solicitação`,
    CLAIM_WITH_NUMBER: `Solicitação {claimNumber}`,
    CLAIMS: `Solicitações`,
    CLAIMS_IN_PROGRESS: `Solicitações em Andamento`,
    CLAIMS_IN_PROGRESS_WITH_COUNT: `Solicitações em Andamento ({count})`,
    CLAIMS_OVERVIEW: `Visão geral das reclamações`,
    CLAIMS_OVERVIEW_TAB: `Visão geral das reclamações ({count})`,
    CLAIMS_WITH_COUNT: `{count} Solicitação(ões)`,
    CLICK_FOR_DETAILS: `(Clique para ver os Detalhes)`,
    CLICK_TO_VIEW_ALL: `Clique para ver tudo`,
    CLOSE: `Fechar`,
    CLOSED_PART_REQUESTS: `Solicitações de peças fechadas`,
    CLOSING: `Fechamento`,
    CLOSING_ACCOUNT: `Fechar Conta`,
    CLOSING_ACCOUNT_WITH_COUNT: `Fechando conta ({count})`,
    CODE: `Código`,
    COLLAPSE_ALL: `Fechar tudo`,
    COMMENT: `Comentário`,
    COMMENTS: `Comentários`,
    COMMENTS_IS_REQUIRED: `Os Comentários são Necessários`,
    COMMENTS_TO_DEALER: `Comentários para o Concessionário`,
    COMMON_LABOR_TYPES_WARNING: `Nem todos os tipos de mão de obra disponíveis para as contas selecionadas`,
    COMPANY: `Empresa`,
    COMPANY_CONTRIBUTION: `Contibuição da Companhia`,
    COMPANY_CONTRIBUTION_IS_REQUIRED: `É necessária a contribuição da empresa`,
    COMPLAINT_CAUSE: `Quais foram os diagnósticos da reclamação?`,
    COMPLAINT_CAUSE_IS_REQUIRED: `Diagnósticos de reclamação são necessários`,
    COMPLAINT_CORRECTION: `Como a reclamação foi reparada?`,
    COMPLAINT_CORRECTION_IS_REQUIRED: `É necessário reparar a reclamação`,
    COMPLETE: `Concluir`,
    COMPLETED: `Completo`,
    COMPLETED_BY: `Executado/Completado por`,
    COMPLETED_DATE: `Data de conclusão`,
    COMPLETED_IN_LAST_24_MONTHS: `Concluído nos últimos 24 meses`,
    COMPLETION_STATUS: `Status da Finalização`,
    COMPONENT: `Componente`,
    COMPONENT_CODE: `Código de Componente`,
    COMPONENT_CREATED_SUCCESSFULLY: `Componente criado com sucesso`,
    COMPONENT_DELETED_SUCCESSFULLY: `Componente excluído com sucesso`,
    COMPONENT_SERIAL_NUMBER: `Número de Série do Componente`,
    COMPONENT_SUCCESSFULLY_UPDATED: `Componente Atualizado com Sucesso`,
    COMPONENTS: `Componentes`,
    CONFIRM: `Confirmar`,
    CONFIRM_ADDITIONAL_REPAIR: `Tem Certeza de que Deseja Adicionar outro Reparo?`,
    CONFIRM_ADJUST_CLAIM: `Tem Certeza de que Deseja Ajustar esta Solicitação?`,
    CONFIRM_CLOSING_ACCOUNT: `Tem certeza de que deseja aceitar esta transferência?`,
    CONFIRM_COPY_CLAIM: `Tem certeza de que deseja copiar esta solicitação?`,
    CONFIRM_DELETE_ATTACHMENT: `Tem certeza de que deseja excluir o arquivo anexado?`,
    CONFIRM_DELETE_CLAIM: `Tem Certeza de que Deseja Excluir esta Solicitação?`,
    CONFIRM_DELETE_MACHINE_STATUS_UPDATE: `Tem certeza de que deseja excluir esta Solicitação de Status da Máquina?`,
    CONFIRM_DELETE_REGISTRATION: `Tem Certeza de que Deseja excluir este Registro?`,
    CONFIRM_EDIT_CLAIM: `Tem Certeza de que Deseja Editar esta Solicitação?`,
    CONFIRM_RECONCILE_CLAIM: `Tem a Certeza de que Deseja Reconciliar esta Solicitação?`,
    CONFIRM_RESEND_XML: `Tem certeza de que deseja reenviar XML? Por favor permitir de 24-48 horas para obter visibilidade.`,
    CONFIRM_SKIP_AUDIT: `Tem certeza de que deseja pular esta auditoria?`,
    CONFIRM_UNDO_REGISTRATION: `Tem certeza de que deseja desfazer este Registro?`,
    CONFIRM_UNRECONCILE_CLAIM: `Tem certeza de que deseja cancelar a reconciliação desta Solicitação?`,
    CONNECTED_MACHINE: `Máquina Conectada`,
    CONTACTED: `Contactado`,
    CONTAINS: `Contém`,
    CONTRACT_NUMBER: `Número do Contrato`,
    CONTRACT_PURCHASED: `Contrato adquirido`,
    CONTRACT_TYPE: `Tipo de contrato`,
    COPY_CLAIM: `Copiar Solicitação`,
    CORE: `Valor`,
    CORE_VALUE: `Valor da Peça Original`,
    COUNTRY: `País`,
    COUNTRY_REQUIRED: `País Necessário`,
    COURIER_ACCOUNT_NUMBER: `Número da Conta da Transportadora`,
    COURIER_NAME: `Nome da Transportadora`,
    COVERAGE_DECISION: `Decisão de Cobertura`,
    COVERAGE_TYPE: `Tipo de Cobertura`,
    CRDMEM: `Nota de Crédito`,
    CREATE: `Criar`,
    CREATE_CLAIM: `Criar Solicitação`,
    CREATE_LAYOUT: `Criar Layout`,
    CREATE_NON_TRACKED_PIN_HELP_TEXT: `Antes de poder criar uma Solicitação para este produto, precisamos de mais algumas informações importantes sobre o mesmo`,
    CREATE_PIP_CLAIM: `Criar Solicitação PMP`,
    CREATE_PIP_CLAIMS: `Criar Solicitações de PMP`,
    CREATE_PRODUCT_RECORD: `Criar registro do Produto`,
    CREATE_REQUEST: `Criar Solicitação`,
    CREATE_TRANSFER_PENDING: `Transferência Pendente`,
    CREATE_TRANSFER_SERVICE_UNAVAILABLE: `Criar Transferências  de Serviço Indisponível`,
    CREATED: `Criado`,
    CREATED_BY: `Criado por`,
    CREATED_DATE: `Data de criação`,
    CREATED_DATE_FROM: `A Partir da Data de Criação`,
    CREATED_DATE_TO: `Até a Data de Criação`,
    CREATED_ON: `Criado em`,
    CREATION_DATE: `Data de Criação`,
    CREDIT_MEMO: `Nota de Crédito`,
    CREDIT_MEMO_DATE: `Data da Nota de Crédito`,
    CREDIT_MEMO_ISSUE_DATE: `Nota de crédito emitida`,
    CREDIT_MEMO_NUMBER: `Número da nota de crédito`,
    CREDIT_MEMO_PROCESS_DATE: `Nota de crédito processada`,
    CREDIT_MEMO_SELECTED: `Nota de Crédito Selecionada`,
    CREDIT_MEMOS: `Notas de Crédito`,
    CRITERIA: `Critérios`,
    CRT: `Criar`,
    CSV_SEPARATOR: `CSV Separator`,
    CURRENCY: `Moeda`,
    CURRENT: `Atual`,
    CURRENT_ACCOUNT: `Conta Corrente`,
    CURRENT_AMOUNT_OF_USE: `Quantidade de Uso atual`,
    CURRENT_CUSTOMER: `Cliente atual`,
    CURRENT_DEALER: `Concessionário Atual`,
    CURRENT_DEALER_DISTANCE: `Distância Atual do Concessionário`,
    CURRENT_DEALER_LAST_SERVICE_DATE: `Última Data de Serviço do Concessionário Atual`,
    CURRENT_DEALER_LOCATION: `Localização Atual do Concessionário`,
    CURRENT_HOURS: `Horas atuais`,
    CURRENT_QUANTITY: `Quantidade atual`,
    CURRENT_RESPONSIBLE_DEALER: `Concessionário responsável atual`,
    CURRENT_VALUES: `Valores atuais`,
    CURRENTLY_ON_RENT: `Atualmente Alugado`,
    CUSTOM_RANGE: `Faixa de Personalização`,
    CUSTOM_VALUES: `Valores personalizados`,
    CUSTOMER: `Cliente`,
    CUSTOMER_CONTRIBUTION: `Contibuição do Cliente`,
    CUSTOMER_CONTRIBUTION_IS_REQUIRED: `É necessária a contribuição do cliente`,
    CUSTOMER_CREATED_SUCCESSFULLY: `Cliente criado com êxito`,
    CUSTOMER_DETAILS: `Detalhes do Cliente`,
    CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: `Detalhes do cliente atualizados com êxito`,
    CUSTOMER_INFORMATION: `Informação ao Cliente`,
    CUSTOMER_INFORMATION_IS_REQUIRED: `A informação do cliente é necessária.`,
    CUSTOMER_INVALID: `Cliente inválido, por favor tente novamente`,
    CUSTOMER_NAME: `Nome do cliente`,
    CUSTOMER_NAME_IS_REQUIRED: `A informação do cliente é necessária.`,
    CUSTOMER_NOT_FOUND: `Cliente não encontrado`,
    CUSTOMER_PROFILE: `Perfil do Cliente`,
    CUSTOMER_REQUIRED: `Cliente obrigatório`,
    CUSTOMER_RESOLUTION: `Resolução do cliente`,
    CUSTOMER_RESOLUTION_IS_REQUIRED: `É necessária a resolução do cliente`,
    CUSTOMER_SEARCH: `Pesquisa de cliente`,
    CUSTOMER_UPDATED_SUCCESSFULLY: `Cliente atualizado com êxito`,
    DAMAGED_MACHINES_HELP_TEXT:`Para máquinas danificadas, a garantia será automaticamente suspensa até que este formulário seja analisado e aprovado pelo TCSM para readmitir a garantia. Máquinas danificadas se enquadram somente em PIPs de Segurança e Obrigatório.`,
    DATE: `Data`,
    DATE_FORMAT: `Formato de Data`,
    DATE_ISSUED: `Data Emitida`,
    DATE_OF_CERTIFIED_LETTER: `Data da carta registrada`,
    DATE_OF_EVENT_CAUSING_DAMAGE:`Data do evento que causou o dano`,
    DATE_OF_LAST_PERSONAL_CONTACT: `Data do último contato pessoal`,
    DATE_RECALLED_PART_WAS_SHIPPED_SENT: `Data que a peça recall foi enviada`,
    DATE_REFUSED: `Data Recusada`,
    DATE_SUBMITTED: `Data de Envio`,
    DAYS_FROM_REGISTRATION: `Dias do Registro`,
    DAYS_LEFT: `Dias Restantes`,
    DAYS_LEFT_WITH_COUNT: `{daysToDisplay} {days, plural, one {dia restante} other {dias restantes}}`,
    DAYS_ON_RENT: `Dias Alugados`,
    DAYS_REMAINING: `Dias restantes`,
    DAYS_REMAINING_WITH_COUNT: `{daysToDisplay} {days, plural, one {dia} other {dias}} restante(s)`,
    DAYS_SINCE_RECOMMENDATION: `{daysToDisplay} {days, plural, one {dia} other {dias}} Desde a Recomendação`,
    DAYS_TO_DISPLAY: `Dias para exibir`,
    DBS: `SEC`,
    DEALER: `Concessionário`,
    DEALER_ACCOUNT: `Conta do concessionário`,
    DEALER_ACCOUNT_IS_REQUIRED: `É necessária a conta do concessionário`,
    DEALER_ACCOUNTS: `Número das Contas do Concessionário`,
    DEALER_CITY: `Cidade do Concessionário`,
    DEALER_COMMENTS: `Comentários do Concessionário`,
    DEALER_CONTRIBUTION: `Contribuição do Concessionário`,
    DEALER_CONTRIBUTION_IS_REQUIRED: `É necessária a contribuição do concessionário`,
    DEALER_HIERARCHY_ACCOUNT: `{account} ({industryIndicator})`,
    DEALER_INVOICE_NUMBER: `Número da Fatura do Concessionário`,
    DEALER_INVOICE_UPDATED: `Fatura do concessionário atualizada`,
    DEALER_INVOICE_UPDATES: `Fatura do concessionário`,
    DEALER_INVOICES: `Faturas do Concessionário`,
    DEALER_LOCATION: `Localização do concessionário`,
    DEALER_LOCATION_FILTER: `Filtrar localizações`,
    DEALER_LOCATION_IS_REQUIRED: `É necessária a localização do concessionário`,
    DEALER_LOCATIONS: `Localizações dos concessionários`,
    DEALER_NAME: `Nome do Concessionário`,
    DEALER_PHONE: `Nº de Tefefone do Concessionário`,
    DEALER_POSTAL_CODE: `Código Postal`,
    DEALER_RECOMMENDATIONS: `Recomendações do Concessionário`,
    DEALER_RECOMMENDATIONS_TAB: `Recomendações do Concessionário ({count})`,
    DEALER_REVIEW_REQUEST_SUCCESSFULLY: `Revisado com Sucesso pelo Concessionário`,
    DEALER_SEARCH: `Pesquisa de Concessionário`,
    DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: `Insira o Nome, Cidade ou Conta para pesquisar por concessionários`,
    DEALER_STATE: `Estado do Concessionário`,
    DEALER_SUBMISSION_WITH_CURRENCY: `Envio do concessionário ({currency})`,
    DEALER_TRANSFER_HISTORY: `Histórico de Transferência do Concessionário`,
    DEALER_TRANSFER_REQUEST_PARTIALLY_SUCCESSFUL: `Algumas Solicitações de Transferência foram criadas com sucesso. Processo restante individualmente.`,
    DEALER_TRANSFER_REQUEST_SUCCESSFULLY: `Solicitação de Transferência do Concessionário Enfileirada com Sucesso`,
    DEALER_WARRANTY: `Garantia do Concessionário`,
    DEALERS: `Concessionários`,
    DEALERSHIP: `Concessionária`,
    DEBIT: `Débito`,
    DEBIT_AMOUNT: `Valor do débito`,
    DEBIT_FOR_CLAIM_NUMBER: `Débito para {claimNumber}`,
    DEBIT_REQUIRED: `Débito obrigatório`,
    DEBIT_REQUIRED_STATUS: `Status do débito é necessário`,
    DEBIT_SUBMITTED_SUCCESSFULLY: `Débito enviado com sucesso`,
    DEBIT_TYPE: `Tipo de débito`,
    DEBITED: `Debitado`,
    DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: `Os débitos para esta solicitação devem ser concluídos através do processo de débito manual`,
    DECIMAL_FORMAT: `Formato Decimal`,
    DECISION_UPDATED: `Decisão Atualizada`,
    DECLINE: `Recusar`,
    DEDUCTIBLE: `Dedutível`,
    DEERE_REMARKS: `Observações da Deere`,
    DEFAULT_WARRANTY: `Garantia Padrão`,
    DEL: `Excluir`,
    DELETE: `Excluir`,
    DELETE_ATTACHMENT: `Excluir anexo`,
    DELETE_CLAIM: `Excluir Solicitação`,
    DELETE_MACHINE_STATUS_UPDATE: `Excluir Atualização do Status da Máquina`,
    DELETE_MACHINE_STATUS_UPDATE_SUCCESS: `Exclusão do Status da Máquina Bem-sucedida`,
    DELETE_REGISTRATION: `Excluir Registro`,
    DELETE_REGISTRATION_SUCCESS: `Exclusão do Registro Realizada com Sucesso`,
    DELETED: `Excluído`,
    DELETED_BY: `Excluído por`,
    DELIVERED: `Entregue`,
    DELIVERED_IS_REQUIRED: `É necessária a entrega`,
    DELIVERY_DATE: `Data de Entrega`,
    DELIVERY_DATE_REQUIRED: `Requer data de entrega`,
    DELIVERY_DATES: `Datas de Entrega`,
    DELIVERY_NO_DOCUMENTS: `Entregue, Nenhum Documento`,
    DEMO_RENTAL_BEGIN_DATE: `Demonstração/Data de início do aluguel`,
    DEMO_RENTAL_CHOOSE_DEALERS_STATUS: `Selecionar Concessionários e Status`,
    DEMO_RENTAL_END_DATE: `Demonstração/Data final do aluguel`,
    DEMO_RENTAL_HISTORY: `Histórico do aluguel  da Demonstração`,
    DENY: `Rejeitar`,
    DENY_AMOUNT_OF_USE: `Negar Quantidade de Uso`,
    DENY_MACHINE_STATUS_UPDATE: `Rejeitar atualização do status da máquina`,
    DENY_PIP_CODE_REQUEST: `Rejeitar pedido de código PMP`,
    DESCENDING: `Decrescente`,
    DESCRIPTION: `Descrição`,
    DESCRIPTION_OF_DAMAGE:`Descrição do dano`,
    DESCRIPTION_OF_EVENT_CAUSING_DAMAGE:`Descrição do evento que causou o dano`,
    DESELECT_ALL: `Cancelar Seleção de Tudo`,
    DETAILS: `Detalhes`,
    DIAGNOSTICS_COVERED: `Diagnósticos abrangidos`,
    DIS_VSR: `Exibir Mensagens`,
    DISPLAY: `Exibição`,
    DISPLAY_CLAIM: `Exibir solicitação`,
    DISPLAY_CREDIT_MEMO: `Exibir nota de crédito`,
    DISPLAY_FORMAT: `Formato de Exibição`,
    DISPLAY_PRODUCT: `Exibir Produto`,
    DISPLAY_TAG: `Exibir Etiqueta`,
    DISTANCE: `Distância`,
    DISTANCE_FROM_CURRENT_DEALER: `Distância do Concessionário Atual`,
    DISTANCE_FROM_POTENTIAL_DEALER: `Distância do Concessionário em Potencial`,
    DISTANCE_FROM_RESPONSIBLE_ACCOUNT: `Distância da Conta Responsável`,
    DIVISION: `Divisão`,
    DIVISION_SUMMARY: `Resumo da Divisão`,
    DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: `Salvar alterações?`,
    DOES_NOT_CONTAIN: `Não contém`,
    DOWNLOAD_TO_EXCEL: `Baixar para o Excel`,
    DOWNTIME: `Tempo da Máquina Parada`,
    DOWNTIME_IS_REQUIRED: `Tempo de máquina parada é necessário`,
    DRAFT: `Salvar como Rascunho`,
    DTAC_CASE: `Caso DTAC`,
    DTAC_CASE_NUMBER: `Número do caso DTAC`,
    DTAC_SOLUTION: `Solução DTAC`,
    DUE_DATE: `Data prevista`,
    DUE_WITHIN_3_MONTHS: `Previsto dentro de 3 meses`,
    DUPLICATE_PIN_PLATE: `Placa do PIN Duplicada`,
    DUPLICATE_PIN_PLATE_REPORT: `Relatório de Placa do PIN Duplicada`,
    DUPLICATE_PIN_PLATE_REQUEST_UPDATED: `Solicitação de Placa do PIN Duplicada Atualizada`,
    DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: `Solicitação de Placa PIN Duplicada Criada com Êxito`,
    DUPLICATE_PIN_PLATE_WITH_COUNT: `Solicitação de Placa do PIN Duplicada ({count})`,
    EDIT: `Editar`,
    EDIT_CUSTOMER: `Editar Cliente`,
    EDIT_LAYOUT: `Editar Layout`,
    EDIT_WITH_PARENTHESES: `(Editar)`,
    EFFECTIVE: `Efetivo`,
    EFFECTIVE_DATE: `Data de vigência`,
    EMAIL: `E-mail`,
    EMISSIONS_PART_SEARCH: `Pesquisa de Peças de Emissões`,
    END_DATE: `Data Final`,
    END_USE: `Uso Final`,
    END_USE_CODE: `Código de uso Final`,
    END_USE_CODE_REQUIRED: `Código de Uso Final obrigatório`,
    ENDS_WITH: `Termina com`,
    ENGLISH: `Inglês`,
    ENTER_A_NUMBER_BETWEEN_0_AND_1000: `Insira um número entre 0 a 1000`,
    ENTER_A_NUMBER_BETWEEN_0_AND_10000: `Insira um número entre 0 e 10 000`,
    ENTER_A_NUMBER_FROM_1_TO_9999: `Insira um número de 1 a 9999`,
    ENTER_A_PART_NUMBER: `Insira o Número da peça`,
    ENTER_COMMENTS_BEFORE_ACCEPTING: `Insira comentários antes de aceitar`,
    ENTITY_ID: `ID da Entidade`,
    EQUALS: `É igual a`,
    ERROR: `ERRO:`,
    ERROR_MESSAGE_TITLE: `Ocorreu um erro:`,
    ERROR_MESSAGES: `Mensagem de Erro`,
    ERROR_MESSAGES_TITLE: `Ocorreram vários erros:`,
    ERROR_NETWORK_ISSUES: `Um erro de Rede fez com que alguns dados não fossem carregados. Por favor, Tente novamente.`,
    ERROR_NO_DATA_TO_EXPORT: `Sem dados para exportar`,
    ERROR_RETRIEVING_CUSTOMER_INFORMATION: `Erro ao recuperar informações do cliente`,
    ERROR_SAP: `Não é possível se conectar ao Servidor. Se o problema persistir, utilize o link "Contacte-nos" para obter assistência na resolução do seu problema.`,
    ERROR_SESSION: `A sua sessão expirou. Atualize a página para voltar a iniciar sessão.`,
    ERROR_UNHANDLED: `O sistema detetou um erro inesperado. Se o problema persistir, utilize a função "Ajuda" ou o link "Contacte-nos" para obter assistência na resolução do seu problema.`,
    ERROR_UPLOADING_FILE: `O Arquivo não foi adicionado`,
    ESTIMATED_BASIC_DATE: `Data Básica Estimada`,
    ESTIMATED_BASIC_DAYS: `Dias Básicos Estimados`,
    ESTIMATED_HOURS: `Horas Estimadas`,
    ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: `As estimativas podem não refletir o status de demonstração ou as horas ainda não relatadas`,
    EXCEEDS_DEMO_THRESHOLD: `Excede o Limite de Demonstração`,
    EXCHANGE_RATE: `Taxa de câmbio`,
    EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: `PINs excluídos não estão incluídos neste relatório.`,
    EXECUTE: `Executar`,
    EXPAND_ALL: `Expandir tudo`,
    EXPECTED_FIRST_USE: `Data esperada do primeiro uso`,
    EXPIRATION_DATE: `Data de Expiração`,
    EXPIRED: `Expirado`,
    EXPIRED_PART_REQUESTS: `Solicitações de peças expiradas`,
    EXPIRED_PIPS: `PMPs Expirado`,
    EXPIRES: `Expirações`,
    EXPIRING_SOON: `Expirando em Breve`,
    EXPORT: `Exportar`,
    EXTENDED_WARRANTY: `Garantia Estendida`,
    FACTORY: `FÁBRICA`,
    FACTORY_DUPLICATE_PIN_PLATE: `Placa do PIN Duplicada`,
    FACTORY_NAME: `Nome da Fábrica`,
    FACTORY_USERS_TAB: `Placa do PIN Duplicada ({count})`,
    FAILED: `Falhou`,
    FAILED_AREA: `Área que falhou`,
    FAILED_AREA_IS_REQUIRED: `É necessária a área da falha`,
    FAILED_DATE: `Data da falha`,
    FAILED_DATE_IS_REQUIRED: `É necessária a data da falha`,
    FAILED_MODE: `Modo da Falha`,
    FAILED_MODE_COMMENTS: `Comentários do Modo da Falha`,
    FAILED_PART: `Peça com falha`,
    FAILED_PART_DESCRIPTION: `Descrição da Peça com falha`,
    FAILED_PART_IS_A_REMAN_PART: `Peça com falha é uma parte do ReMan`,
    FAILED_PART_IS_REQUIRED: `É necessária a peça com falha`,
    FAILED_PART_SERIAL: `Série da peça com falha`,
    FAILED_PART_SERIAL_IS_REQUIRED: `É necessária a série da peça com falha`,
    FAILURE_DATE: `Data da Falha`,
    FAILURE_INFORMATION: `Informação da Falha`,
    FAILURE_MODE: `Código da Falha`,
    FAILURE_MODE_IS_REQUIRED: `É necessário o Modo da Falha`,
    FAILURE_PART: `Peça com falha`,
    FAILURE_PART_DESCRIPTION: `Descrição da Peça com falha`,
    FAILURE_PART_IS_REQUIRED: `É necessária a peça com falha`,
    FAILURE_TO_RETURN_PARTS_WARNING: `Não devolver as partes solicitadas pode resultar em um débito.`,
    FAVORITES: `Favoritos`,
    FILE_NAME: `Nome do Arquivo`,
    FILE_SIZE_IS_TOO_BIG: `O arquivo é demasiado grande (tamanho máximo 100 MB)`,
    FILE_SIZE_IS_TOO_BIG_CSV: `O arquivo é demasiado grande (tamanho máximo 1 MB)`,
    FILE_UPLOAD_MESSAGE: `Libere os  arquivos aqui ou clique para adicionar arquivos (tamanho máximo 100 MB)`,
    FILE_UPLOAD_MESSAGE_CSV: `Libere os  arquivos aqui ou clique para adicionar arquivos (tamanho máximo 1 MB)`,
    FILE_UPLOAD_MESSAGE_IMAGE: `Libere as imagens aqui ou clique para adicionar imagens (tamanho máximo 100 MB)`,
    FILE_UPLOAD_MESSAGE_SINGLE: `Arraste um únicoarquivo  aqui ou clique em adicionar (tamanho máximo 100 MB)`,
    FILE_UPLOAD_UNABLE_TO_READ: `O sistema não pôde ler seu arquivo.  Compare-o com o modelo e tente novamente.`,
    FILES: `Arquivos`,
    FILTER_DEALER_RECOMMENDATIONS_MESSAGE: `Nenhum resultado. Pressione Enter para pesquisar todas as recomendações.`,
    FILTER_PLACEHOLDER: `Filtrar resultados`,
    FILTER_WITH_ELLIPSIS: `Filtrar..."`,
    FILTERED_BY_COLUMN_ID: `Filtrado por {columnId}`,
    FIND_CUSTOMER: `Encontre o Cliente`,
    FINNISH: `Finlandês`,
    FIRST_MAINTENANCE: `PRIMEIRA MANUTENÇÃO`,
    FIRST_NAME: `Primeiro Nome`,
    FIRST_NAME_IS_REQUIRED: `É necessário o nome próprio`,
    FIRST_SHIP_TO_LOCATION: `Primeiro envio para o local`,
    FIRST_USE: `Usado pela primeira vez`,
    FISCAL_YEAR: `Ano fiscal`,
    FLUID_SAMPLING_REQUIRED: `É necessária uma amostra de fluído`,
    FORWARDED: `Encaminhado`,
    FRENCH: `Francês`,
    FROM: `De`,
    FRWRD: `Enviar`,
    FULL_DEBIT: `Débito Total`,
    GENERAL: `Geral`,
    GERMAN: `Alemão`,
    GET_MAINTENANCE_PLANS: `Obter planos de manutenção`,
    GOODS_INSTALLATION_VAT: `IVA da instalação de produtos`,
    GRACE_PERIOD: `Período de Gracias`,
    GREATER_THAN: `Melhor que`,
    GREATER_THAN_OR_EQUALS: `Melhor que ou igual`,
    GROUP_COMPLETE: `Grupo Completo`,
    GST_PERCENTAGE: `GST Porcentagem`,
    H_LIMIT: `Limite de horas`,
    HISTORY_TO_DISPLAY: `Mostrar Histórico (dias)`,
    HOME: `Principal`,
    HOUR_LIMIT: `Limite de horas`,
    HOURS: `Horas`,
    HOURS_ON_RENT: `Horas de aluguel`,
    HSN_SAC_CODE: `HSN/SAC Código`,
    IGST: `IGST`,
    IMPLEMENTS: `Implementos`,
    IN_RANGE: `No Alcance`,
    INCENTIVE: `Incentivo`,
    INCENTIVE_PROGRAMS: `Programas de incentivo`,
    INCLUDE_FULLY_COMPLETE: `Incluir PIPs Completamente Completos`,
    INDICATES_REQUIRED_FIELD: `Indica um campo obrigatório`,
    INFO_MESSAGE_TITLE: `Foi enviada uma notificação do Sistema:`,
    INFO_MESSAGES: `Mensagens de informação`,
    INFO_MESSAGES_TITLE: `Foram enviadas várias notificações do sistema:`,
    INFO_REQUEST_STATUS_ERROR: `As informações estão prontas para serem enviadas com essa solicitação.`,
    INFORMATION: `Em formação`,
    INFORMATION_REQUEST: `Solicitação de Informações`,
    INFORMATION_REQUEST_STATUS: `Status da Solicitação de Informações`,
    INPUT_PIN: `Introduzir PIN`,
    INSPECTION: `Inspeção`,
    INSTALLED_BY: `Instalado por`,
    INSTALLED_BY_IS_REQUIRED: `É necessária a informação do responsável pela instalação`,
    INTERNAL_DEERE_COMMENTS: `Comentários Internos Deere`,
    INTERNAL_EQUIPMENT_NOTES: `Observações do Equipamento Interno`,
    INTERVAL_BEGINS: `Início do Intervalo`,
    INTERVAL_ENDS: `Fim do Intervalo`,
    INTERVAL_TYPE_DESCRIPTION: `Descrição do Tipo de Intervalo`,
    INVOICE_ACCOUNT: `Conta de Fatura`,
    INVOICE_DEALER: `Fatura do Concessionário`,
    INVOICE_NUMBER: `Número da Fatura`,
    INVOICE_REQUEST: `Pedido de fatura`,
    INVOICE_SENT: `Fatura enviada`,
    INVOICE_UPDATED_SUCCESSFULLY: `Atualização de faturas com sucesso`,
    INVOICED: `Faturado`,
    INVOICED_TO: `Faturado para`,
    IRC_PIN_MESSAGE: `O cliente é um IRC e tem o direito a um tempo de deslocamento e quilometragem complementares pelas primeiras 500 horas ou 12 meses de propriedade da máquina.`,
    ISSUED: `Emitido`,
    ITALIAN: `Italiano`,
    ITEM: `Item`,
    ITEM_NUMBER: `Número do item`,
    ITEM_NUMBER_IS_REQUIRED: `É necessário o Número do Ítem`,
    JDLINK_EXPIRES: `JDLink Expira`,
    JDP_COMMENTS: `JDP Comentários`,
    JDP_COMMENTS_IS_REQUIRED: `São necessários os comentários JDP`,
    JDP_CUSTOMER_RESOLUTION: `Resolução do Cliente JDP`,
    JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: `É necessária a resolução do cliente JDP`,
    JDP_REASON: `Motivo JDP`,
    JDP_REASON_IS_REQUIRED: `É necessário o motivo JDP`,
    LABOR: `Mão de Obra`,
    LABOR_ADDITIVE: `Suplemento de mão de Obra`,
    LABOR_ADDITIVE_COMPLETION_DETAIL: `Detalhe de Conclusão do Aditivo de Trabalho`,
    LABOR_ADDITIVE_PIPS: `Mão de Obra - Aditivos PMPs`,
    LABOR_ADDITIVE_TAB: `Aditivo de Mão de Obra ({count})`,
    LABOR_ADJUSTMENT: `Ajuste de mão de obra`,
    LABOR_COMMENTS: `Comentários de Mão de Obra`,
    LABOR_HOURS: `Mão de Obra`,
    LABOR_ITEM_DETAILS: `Mão de Obra - {quantity} {unit} {description}`,
    LABOR_RATE_APPROVED_SUCCESSFULLY: `Valor de Mão de Obra aprovado com sucesso`,
    LABOR_RATE_CHANGE_SUBMITTED: `Alteração do valor  de Mão de Obra enviada`,
    LABOR_RATE_CHANGES_WITH_COUNT: `Alterações do valor de Mão de Obra ({count})`,
    LABOR_RATE_CONFIRM: `O preço solicitado é inferior aos preço atual. Tem a certeza de que pretende submeter o Pedido?`,
    LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: `Taxas no texto vermelho indicam aumento de mais de 10% da taxa existente`,
    LABOR_RATE_HISTORY: `Histórico da valor de mão de obra`,
    LABOR_RATE_REJECTED_SUCCESSFULLY: `Valor de Mão de Obra rejeitado com sucesso`,
    LABOR_RATE_REQUESTS_STATUS: `Status de Solicitações da Taxa de Mão de Obra`,
    LABOR_RATE_RETURNED_SUCCESSFULLY: `Taxa de mão de obra retornada com sucesso`,
    LABOR_RATES: `Valores de mão de obra`,
    LABOR_STATS: `Estatísticas de mão de obra`,
    LABOR_TOTAL: `Total de Mão de Obra`,
    LABOR_TYPE: `Tipo de mão de obra`,
    LABOR_VALUE: `Valor da mão de obra`,
    LABOR_WITH_COUNT: `Trabalho ({count})`,
    LANGUAGE: `Idioma`,
    LAST_LOCATION_FROM: `Último Local de`,
    LAST_NAME: `Sobrenome`,
    LAST_NAME_IS_REQUIRED: `É necessário o Sobrenome`,
    LAST_PERSONAL_CONTACT: `Último Contato Pessoal`,
    LAST_SEEN: `Visto pela Última Vez`,
    LAST_SEEN_AT_RESPONSIBLE_ACCOUNT: `Visto Pela Última Vez Na Conta Responsável`,
    LATEST: `Mais Recente`,
    LAW_ENFORCEMENT_AGENCY_DETAILS: `Detalhes da Agência de aplicação da Lei`,
    LAYOUT_CREATED_SUCCESSFULLY: `Layout criado com sucesso`,
    LAYOUT_DELETED_SUCCESSFULLY: `Layout apagar com Sucesso`,
    LAYOUT_NAME: `Nome de layout`,
    LAYOUT_UPDATED_SUCCESSFULLY: `Layout atualizado com sucesso`,
    LEAD_ACCOUNT: `Conta Líder`,
    LEAD_DEALER: `Concessionário Líder`,
    LESS_THAN: `Menos que`,
    LESS_THAN_OR_EQUALS: `Menor ou igual`,
    LICENSE_PLATE_NUMBER: `Número da Placa de Licenciamento`,
    LIFETIME: `Garantia Vitalícia`,
    LINE_ITEMS_EXPORT: `Exportação de itens de linha`,
    LIST: `Lista`,
    LIST_TOTAL: `Total da lista`,
    LOCATION: `Local`,
    LOCATION_DUE: `Localização prevista`,
    LOCATIONS: `Locais`,
    LOCATIONS_WITH_COUNT: `Localizações ({count})`,
    MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: `A máquina já está registada para este cliente`,
    MACHINE_INFORMATION: `Informação da Máquina`,
    MACHINE_MODEL_TYPE: `Modelo/Tipo de Máquina`,
    MACHINE_MODEL_TYPE_REQUIRED: `Modelo/Tipo de Máquina Necessário`,
    MACHINE_STATUS: `Status da Máquina`,
    MACHINE_STATUS_UPDATE: `Atualização do Status da Máquina`,
    MACHINE_STATUS_UPDATE_ACCEPTED: `Atualização do status da Máquina aprovada`,
    MACHINE_STATUS_UPDATE_DOCUMENT: `Documento de atualização do status da Máquina`,
    MACHINE_STATUS_UPDATE_REJECTED: `Atualização do status da Máquina rejeitada`,
    MACHINE_STATUS_UPDATES_WITH_COUNT: `Atualizações do status da Máquina ({count})`,
    MACHINE_TYPE: `Tipo da Máquina`,
    MACHINE_TYPE_IS_REQUIRED: `É necessário o tipo de máquina`,
    MACHINE_USE: `Uso da Máquina`,
    MAILING_RECIPIENT: `Destinatário para Correspondência (Nome e Sobrenome)`,
    MAILING_RECIPIENT_REQUIRED: `Destinatário para Correspondência Necessário`,
    MAINTENANCE: `Manutenção`,
    MAINTENANCE_PLAN: `Planos de Manutenção`,
    MAINTENANCE_PLAN_INFO: `Informações do Plano de Manutenção`,
    MARK_AS_INPROCESS: `Marcar como Em Andamento`,
    MARK_AS_REVIEW: `Marque como Revisado`,
    MARKETING_INCENTIVE: `Marketing — Incentivo`,
    MARKETING_JD_PROMISE: `Marketing – Compromisso da JD`,
    MARKETING_MAINTENANCE_PLAN: `Marketing – Plano de manutenção`,
    MARKETING_MASS_CHANNEL_FOLLOWUP: `Marketing – Acompanhamento do canal de grande volume`,
    MARKETING_MASS_CHANNEL_PDI: `Marketing – Canal de grande volume PDI`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP: `Acompanhamento do Cliente do comércio de auto-serviço massivo`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: `Lembrete. Por favor,  entre em contato com seu próprio Representante Legal para determinar os apropriados #Do Not Call# procedimentos dentro do seu Estado e das Autoridades Legais antes de implementar o Programa de Chamada de Acompanhamento Pós-venda`,
    MASS_CHANNEL_PDI_CLAIM: `Canal de grande volume PDI`,
    MASTER_WARRANTY_TYPE: `Tipo de Garantia Principal`,
    MATERIAL: `Número do Material`,
    MERCHANDISE: `Mercadorias`,
    MESSAGE: `Mensagem`,
    MESSAGES: `Mensagens`,
    METHOD_OF_CONTACT: `Método de Contato`,
    METHOD_OF_CONTACT_IS_REQUIRED: `É necessário o método de contacto`,
    METRIC: `Métrica`,
    METRICS: `Métricas`,
    MILEAGE_LIMIT: `Limite de Milhagem`,
    MOBILE_PHONE: `Telefone Móvel`,
    MODEL: `Modelo`,
    MODEL_NUMBER: `Número do Modelo`,
    MODEL_YEAR: `Ano-Modelo`,
    MODIFIED: `Modificado`,
    MONTH_TO_DATE: `Mês até a Data`,
    MORE: `Mais`,
    MULTIPLE: `Múltiplos`,
    NAME: `Nome`,
    NET: `Líquido`,
    NET_AMOUNT: `Montante líquido`,
    NET_AMOUNT_PAID: `Montante líquido pago`,
    NET_TOTAL: `Total Líquido`,
    NEW: `Novo`,
    NEW_ACCOUNT: `Nova Conta`,
    NEW_CLAIM: `Nova solicitação`,
    NEW_CLAIM_VALUE: `Valor da Nova Solicitação`,
    NEW_CUSTOMER_REQUIRED: `Novo Cliente obrigatório`,
    NEW_DEALER: `Novo Concessionário`,
    NEW_DEALER_DISTANCE: `Nova Distância do Concessionário`,
    NEW_DEALER_LOCATION: `Nova Localização do Concessionário`,
    NEW_LABOR_RATE: `Novo preço de mão de obra`,
    NEW_REQUEST_ENTER_RATES: `Nova Solicitação - Inserir Taxas`,
    NEW_STATUS: `Novo Status`,
    NEW_TRANSFER: `Nova Transferência`,
    NEW_TRANSFER_CREATED: `Nova Transferência Criada`,
    NEW_VALUE: `Novo valor`,
    NO: `Não`,
    NO_ACTIVE_WARRANTY: `Nenhuma Garantia Ativa`,
    NO_AFFECTED_PINS: `Não existem PINs afetados sob a responsabilidade do seu concessionário`,
    NO_AUTHORITY_TO_ACCESS: `Você não tem autoridade para acessar o JDWS. Usuários do concessionário, favor acompanhar o Administrador de Perfil (DPA) para verificar se a autoridade e os usuários da Deere entram em contato com o Suporte com uma cópia desse erro aqui`,
    NO_CLAIMS: `Não existem Solicitações`,
    NO_CUSTOMER_ASSOCIATED: `Nenhum Cliente Associado`,
    NO_CUSTOMER_SELECTED: `Nenhum cliente selecionado`,
    NO_DEALER_INVOICES: `Nenhuma fatura do concessionário`,
    NO_DEALERS_MAPPED: `Não existem Concessionários mapeados para a sua ID de usuário. Por favor, contate o Administrador do Sistema.`,
    NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE:`Não (nesse caso, forneça uma imagem como evidência)`,
    NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: `Nenhuma informação disponível para este Produto`,
    NO_LABOR_COVERAGE: `Sem Cobertura de Mão de Obra`,
    NO_LOWERCASE: `Não`,
    NO_MATCHING_DEALERS: `Nenhum dos concessionários corresponde ao texto do filtro.`,
    NO_OPEN_PART_REQUESTS: `Nenhum solicitações de peça aberta`,
    NO_OPEN_PIPS: `Nenhum PMP aberto`,
    NO_PARTS_RETURNED: `Nenhuma peça devolvida`,
    NO_PIP_PRODUCTS: `Não há produtos PMP.`,
    NO_PRODUCT_FOUND: `Nenhum Produto Encontrado`,
    NO_REQUIRED_ITEMS: `Não há itens obrigatórios.`,
    NO_RESULTS: `Sem resultados`,
    NO_RESULTS_FOUND: `Não Foi Encontrado Nenhum Resultado`,
    NO_ROWS_TO_SHOW: `Sem linhas para mostrar`,
    NO_SPECIAL_INSTRUCTIONS: `Não há instruções obrigatórias.`,
    NO_TRAVEL: `Nenhum Deslocamento`,
    NON_RECOVERABLE_TAXES: `Impostos Não Recuperáveis`,
    NON_TRACKED_PINS_HELP_TEXT: `Alguns Produtos não aparecem na Garantia até terem sido registrados. A sua pesquisa refere-se a este Produto`,
    NON_TRAVEL: `Sem Viagem`,
    NONE: `Nenhum`,
    NORMAL: `NORMAL`,
    NOT_EQUAL: `Não igual`,
    NOTIFICATION_ADDED_SUCCESSFULLY:`Notificação adicionada com sucesso`,
    NOTIFICATION_DELETED_SUCCESSFULLY:`Notificação excluída com sucesso`,
    NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: `Sequência de notificação atualizada com sucesso`,
    NOTIFICATION_UPDATED_SUCCESSFULLY:`Notificação atualizada com sucesso`,
    NOTIFICATIONS: `Notificações`,
    NUMBER_OF_DIAGNOSTICS_OCCURRENCES: `Número de ocorrências de diagnósticos`,
    NUMBER_OF_OPEN_PIPS: `{number} PMP aberto(s)`,
    NUMBER_OF_REPAIR_OCCURRENCES: `Número de ocorrências de reparações`,
    NUMBER_OF_REPLACEMENT_OCCURRENCES: `Número de ocorrências de substituições`,
    OLD_LABOR_RATE: `Preço de mão de obra antigo`,
    ON_SHELF: `Na prateleira`,
    ON_SHELF_COST: `Custo posto na prateleira`,
    ONE_ITEM_MUST_BE_SELECTED: `É necessário selecionar uma opção`,
    OPEN: `Abrir`,
    OPEN_PART_REQUESTS: `Pedidos de peça(s) abertos`,
    OPEN_PART_REQUESTS_WITH_COUNT: `Pedidos de Peça(s) Abertos ({count})`,
    OPEN_PIP_COUNT: `Contagem de PIP aberta`,
    OPEN_PIP_PROGRAMS: `Registro de PMP`,
    OPEN_PIPS: `Abrir PMP`,
    OPEN_PIPS_REPORT: `Relatório de PMP incompleto`,
    OPEN_PIPS_TAB: `Abrir PMPs ({count})`,
    OPEN_PIPS_Y_N: `PMPs Abertos (S/N)`,
    OPERATORS_COMPLAINT: `Qual foi a reclamação do operador?`,
    OPERATORS_COMPLAINT_IS_REQUIRED: `É necessário ter a reclamação do operador`,
    OPERATORS_MANUAL_NUMBER: `Numero do manual do operador`,
    OPTION_CODES: `Código de Opções`,
    OR: `ou`,
    ORIGINAL_CLAIM_VALUE: `Valor da Solicitação Original`,
    ORIGINAL_SUBMISSION_DATE: `Data de envio original`,
    ORIGINALLY_SUBMITTED: `Submetido originalmente`,
    OTHER: `Outro`,
    OTHER_AMOUNT_OF_USE: `Outra Quantidade de Uso`,
    OTHER_AMOUNT_OF_USE_REQUIRED: `Outra Quantidade de Uso Obrigatória`,
    OTHER_CREDIT: `Outros Créditos`,
    OTHER_CREDIT_1: `Outros Créditos 1`,
    OTHER_CREDIT_2: `Outros Créditos 2`,
    OTHER_CREDIT_3: `Outros Créditos 3`,
    OTHER_CREDIT_ADJUSTMENT: `Ajuste de Outros Créditos`,
    OTHER_CREDIT_ITEM_DETAILS: `Outros Créditos - {description} ({quantity} {unit})`,
    OTHER_CREDIT_TOTAL: `Total de outros créditos`,
    OTHER_CREDITS: `Outros Créditos`,
    OTHER_CREDITS_WITH_COUNT: `Outros créditos ({count})`,
    OTHER_INSTRUCTIONS: `Outras instruções`,
    OUTPUT_PIN: `Resultado do número de série`,
    OVERDUE: `Atrasado`,
    OVERRIDE_ACCOUNT: `Cancelar Conta`,
    OVERRIDE_EFFECTIVE_DATE: `Data de Vigência da Substituição`,
    OVERRIDE_SUGGESTED_ACCOUNT: `Cancelar Conta Sugerida`,
    OWNERSHIP_STATUS: `Status de Propriedade`,
    OWNERSHIP_STATUS_IS_REQUIRED: `É necessário o status da propriedade`,
    PART: `Peça`,
    PART_1: `Peça 1`,
    PART_2: `Peça 2`,
    PART_3: `Peça 3`,
    PART_4: `Peça 4`,
    PART_5: `Peça 5`,
    PART_6: `Peça 6`,
    PART_7: `Peça 7`,
    PART_8: `Peça 8`,
    PART_9: `Peça 9`,
    PART_10: `Peça 10`,
    PART_AMONT_OF_USE: `Volume de utilização da peça`,
    PART_FAMILY: `Família da Peça`,
    PART_ITEM_DETAILS: `Peças - {quantity} {description} Número da Peça {partNumber}`,
    PART_NUMBER: `Número da Peça`,
    PART_REQUEST: `Solicitação de Peça`,
    PART_REQUEST_NUMBER: `Solicitação de Peça {rgaNumber}`,
    PART_REQUEST_STATUS: `Status de Solicitação de Peça`,
    PART_REQUESTS: `Solicitações de Peças`,
    PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: `Introduza o número da reclamação, no mínimo 4 caracteres`,
    PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: `A Pesquisa da Solicitação deve ter, pelo menos, 4 caracteres`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: `A pesquisa do número de caso DTAC deve ser o número de caso DTAC completo, pelo menos 4 caracteres`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: `Introduza o número de caso DTAC completo`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: `A Pesquisa do número da peça deve ter, pelo menos, 4 caracteres`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: `Introduza o número da peça, no mínimo 4 caracteres`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: `A pesquisa do número da peça deve ter, pelo menos, 4 caracteres`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: `Introduza o número de pedido da peça, no mínimo 4 caracteres`,
    PART_REQUESTS_SEARCH_BY_PIN_ERROR: `A pesquisa do PIN deve ter, pelo menos, 4 caracteres`,
    PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: `Introduza o PIN, no mínimo 4 caracteres`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: `A pesquisa da ordem de serviço deve ser a ordem de serviço completa, pelo menos 2 caracteres`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: `Introduza a ordem de serviço completa`,
    PART_REQUESTS_UPDATED_SUCCESSFULLY: `Pedido da peça atualizado com êxito`,
    PART_RETURN: `Retorno de Peça`,
    PART_RETURNS: `Retornos de Peças`,
    PART_SERIAL_NUMBER: `Número de Série da Peça`,
    PART_SERIAL_NUMBER_IS_REQUIRED: `É necessário o número de série da peça`,
    PART_TOTAL: `Total de peças`,
    PART_TYPE: `Tipo de peça`,
    PART_USE: `Utilização da peça`,
    PART_VALUE: `Valor da Peça`,
    PARTIAL_DEBIT: `Débito Parcial`,
    PARTICIPANT: `Participante`,
    PARTS: `PEÇAS`,
    PARTS_ADDITIVE: `Aditivo Peças`,
    PARTS_ADJUSTMENT:`Ajuste de Peças`,
    PARTS_COVERAGE_SEARCH: `Pesquisa de Cobertura de Peças`,
    PARTS_TEMPLATE: `Modelo de Peças`,
    PARTS_USE: `Uso da Peça`,
    PARTS_USE_IS_REQUIRED: `É necessária a utilização de peças`,
    PARTS_WITH_COUNT: `Peças ({count})`,
    PARTS_WITH_PARENTHESES: `Peça(s)`,
    PAST_DUE: `Vencido`,
    PAYER_ACCOUNT: `Conta do Pagador`,
    PC_LIMIT:`Limite do Fardo`,
    PERCENT_COMPLETE: `Percentagem Completa`,
    PERCENTAGE: `Porcentagem`,
    PERCENTAGE_DEBIT: `Débito Percentual`,
    PERCENTAGE_SYMBOL: `{percentage}%`,
    PERCENTAGE_TO_DEBIT: `Porcentagem para Débito`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT:`Para máquinas permanentemente fora de serviço, inclua uma imagem da máquina para verificação de que ela não pode ser reconstruída, reparada ou usada futuramente. Máquinas permanentemente fora de serviço não se enquadram em PIPs de nenhum tipo.`,
    PERSON_RESPONSIBLE: `Pessoa Responsável`,
    PHONE: `Telefone`,
    PHONE_REQUIRED: `Telefone Necessário`,
    PICTURE: `Imagem`,
    PICTURE_REQUEST: `Solicitação de Imagens`,
    PICTURE_REQUEST_STATUS: `Status da Solicitação de Imagens`,
    PICTURE_REQUEST_STATUS_ERROR: `Os anexos estão prontos para serem enviados com essa solicitação.`,
    PIN: `Nº de Série`,
    PIN_CREATED_SUCCESSFULLY: `PIN criado com sucesso`,
    PIN_CROSS_REFERENCE: `Referência Cruzada  de número de série`,
    PIN_INVALID: `PIN Inválido`,
    PIN_IS_REQUIRED: `O Número de Identificação do Produto (PIN) é obrigatório.`,
    PIN_REQUIRED: `PIN Obrigatório`,
    PIN_SEARCH: `Pesquisa por Pino`,
    PIN_SEARCH_INFORMATION: `Informações de Pesquisa de Pino`,
    PIN_TRANSFER_INFORMATION: `Informações de Transferência de Pino`,
    PINS: `PINs`,
    PINS_NOT_REGISTERED: `Máquina sem Registro`,
    PIP: `Programa de Melhoria de Produto (PMP)`,
    PIP_CODE: `Código PMP`,
    PIP_CODE_CREATED_SUCCESSFULLY: `Pedido de código PIP criado com êxito`,
    PIP_CODE_REQUEST: `Solicitação de código PMP`,
    PIP_CODE_REQUEST_APPROVED: `Pedido de código PMP aprovado`,
    PIP_CODE_REQUEST_REJECTED: `Pedido de código PMP rejeitado`,
    PIP_CODE_REQUESTS_WITH_COUNT: `Pedidos de código PMP ({count})`,
    PIP_COMPLETION_STATUS: `Status PMP Completo`,
    PIP_DETAILS: `Detalhes do PMP`,
    PIP_HISTORY: `Histórico de PMPIP`,
    PIP_ID: `PMP Nº`,
    PIP_NUMBER: `Nº do PMP`,
    PIP_PROGRAM: `Programa PMP`,
    PIP_PROGRAM_IS_REQUIRED: `É necessário o programa PMP`,
    PIP_PROGRAMS: `Programas PMP`,
    PIP_SEARCH: `Busca do PMP`,
    PIP_STATUS: `Status de PMP`,
    PIP_TYPE: `Tipo de PMP`,
    PIP_TYPES: `Tipos de PMP`,
    PIPS: `PMPs`,
    PIPS_UNPAID_LABOR_ADDITIVE: `Aditivos  de Mão de Obra não pago nos PMP`,
    PLAN_DESCRIPTION: `Descrição do Plano`,
    PLAN_END_DATE: `Planejar Data Final`,
    PLAN_ENDS: `Planejar Data final`,
    PLAN_NAME: `Nome do Plano`,
    PLAN_NAME_IS_REQUIRED: `É necessário o nome do plano`,
    PLAN_NAMES: `Nomes do Plano`,
    PLAN_START_DATE: `Data de Início do Plano`,
    PLAN_STARTS: `Planejar Data inicial`,
    PLANNED_BY: `Planejado por`,
    PLANT: `Planta`,
    PLATE_REQUEST_INFORMATION: `Informações de Solicitação de Placa`,
    PLEASE_SELECT_A_LEAD_ACCOUNT: `Selecione uma conta principal`,
    PLEASE_SELECT_CLAIM_TYPE: `Por Favor, Selecione o Tipo de Solicitação`,
    POLISH: `Polonês`,
    PORTUGUESE: `Português`,
    POSTAGE_DELIVERY_DATE: `Data de entrega da postagem`,
    POSTAL_CODE: `Código Postal`,
    POSTAL_CODE_REQUIRED: `Código Postal Necessário`,
    POSTAL_TRACKING_NUMBER: `Número de rastreamento postal`,
    POTENTIAL_RESPONSIBLE_DEALER: `Concessionário potencialmente responsável`,
    PRE_DELIVERY_INSPECTION: `Inspeção Pré-Entrega`,
    PREFERRED_THEME: `Tema Preferido`,
    PREPARE_AUDIT: `Preparar Auditoria`,
    PREPARED: `Preparado`,
    PREPARING_AUDIT_FOR_WITH_DEALER: `Preparar a Auditoria para {dealer}`,
    PREVIOUS_AMOUNT_OF_USE: `Quantidade de Uso anterior`,
    PREVIOUS_INVOICE_NUMBER: `Número da fatura anterior`,
    PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: `É necessário o número da fatura anterior`,
    PREVIOUS_MONTH: `Mês Anterior`,
    PRICE: `Preço`,
    PRICING_SUMMARY: `Resumo dos preços`,
    PRIMARY_ACTION: `Ação Primária`,
    PRIMARY_LANGUAGE: `Idioma Primário`,
    PRINT: `Imprimir`,
    PRINT_CLAIM: `Imprimir reclamação`,
    PRINT_REGISTRATION_FORM: `Imprimir Formuláario de Registro`,
    PRINT_REGISTRATION_FORM_MESSAGE: `Produto Registrado para o Primeiro Dono. Gostaria de Imprimir o Formulário de Registro Agora?`,
    PRINT_TO_PDF: `Imprimir PDF`,
    PRIORITY: `Prioridade`,
    PRNT_CLM: `Exibir solicitação`,
    PROCESS_DATE: `Data de processamento`,
    PROCESSED: `Processado`,
    PROCESSED_PART_REQUESTS: `Solicitações de peça processada`,
    PROCESSING_STATUS: `Situação de processamento`,
    PROCESSING_STATUS_DESCRIPTION: `Descrição da Situação do processamento`,
    PRODUCT_DETAILS: `Detalhes do Produto`,
    PRODUCT_HIERARCHY: `Hierarquia de Produtos`,
    PRODUCT_INFORMATION: `Informação do Produto`,
    PRODUCT_REGISTERED: `Produto Registrado`,
    PRODUCT_REGISTRATION: `Registros do Produto`,
    PRODUCT_REGISTRATION_PENDED: `Registro do produto está pendente`,
    PRODUCT_TRACKING: `Rastreamento do Produto`,
    PRODUCTS: `Produtos`,
    PRODUCTS_BY_CUSTOMER: `Produtos por Cliente`,
    PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: `PINs históricos podem estar faltando nos resultados da pesquisa devido a um problema temporário de conectividade do sistema`,
    PRODUCTS_WITH_COUNT: `Produtos ({count})`,
    PROGRAM: `Programa`,
    PROGRAM_DESCRIPTION: `Descrição do Programa`,
    PROGRAM_IS_REQUIRED: `O nome do programa é obrigatório.`,
    PROGRAM_NAME: `Nome do Programa`,
    PROGRAM_NAME_IS_REQUIRED: `O nome do programa é obrigatório.`,
    PROGRAM_NUMBER: `Número do Programa`,
    PRT: `PRT`,
    PRTS: `PRTs`,
    PURCHASE_INFO: `Informações de Compra`,
    PURCHASE_ORDER: `Ordem de compra`,
    PURCHASE_ORDER_IS_REQUIRED: `É necessária a ordem de compra`,
    PURCHASER_TYPE: `Tipo de Compra`,
    PURCHASER_TYPE_REQUIRED: `Tipo de Comprador Obrigatório`,
    PUSH_XML: `Reenviar XML`,
    QTY: `Quantidade`,
    QUALIFY_FOR_EMISSIONS: `Qualificar para Emissões`,
    QUANTITY: `Quantidade`,
    QUANTITY_1: `Quantidade 1`,
    QUANTITY_2: `Quantidade 2`,
    QUANTITY_3: `Quantidade 3`,
    QUANTITY_4: `Quantidade 4`,
    QUANTITY_5: `Quantidade 5`,
    QUANTITY_6: `Quantidade 6`,
    QUANTITY_7: `Quantidade 7`,
    QUANTITY_8: `Quantidade 8`,
    QUANTITY_9: `Quantidade 9`,
    QUANTITY_10: `Quantidade 10`,
    QUERY_MUST_CONTAIN_3_CHARACTERS: `A consulta deve conter no mínimo 3 caracteres`,
    QUEST_DESC: `Descrição do Questionário`,
    QUESTIONABLE_PART: `Peça Questionável`,
    QUEUED: `Em fila`,
    READING_DATE: `Data de Leitura`,
    REASON: `Motivo`,
    REASON_EVENT_NUMBER: `Número do Evento do Motivo`,
    REASON_FOR_CHANGE: `Razão para trocar`,
    REASON_FOR_DEBIT: `Motivo para o Débito`,
    REASON_FOR_MISSING_PLATE: `Motivo para a Placa Ausente`,
    REASON_FOR_MISSING_PLATE_REQUIRED: `Motivo para a Falta da Placa Necessária`,
    REASON_FOR_OVERRIDE: `Motivo para a Substituição`,
    REASON_FOR_REFUSAL: `Motivo da Recusa`,
    REASON_FOR_RETURN: `Motivo da devolução`,
    REASON_FOR_RETURN_IS_REQUIRED: `É necessário o motivo da devolução`,
    REASON_FOR_TRANSFER: `Motivo para Transferência`,
    REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: `O Motivo para a Transferência deve Conter caracteres alfanuméricos`,
    REASON_FOR_TRANSFER_REJECTION: `Motivo da Rejeição da Transferência`,
    RECIPIENT_DEALER_OR_TCSM: `Destinatário (Concessionário ou TCSM)`,
    RECIPIENT_MAILING: `Destinatário para Correspondência`,
    RECOMMENDATION: `Recomendação`,
    RECOMMENDATION_DATE: `Data da Recomendação`,
    RECOMMENDED_ACCOUNT: `Conta Recomendada`,
    RECONCILE: `Reconciliar`,
    RECONCILE_CLAIM: `Reconciliar a Solicitação`,
    RECONCILED: `RECONCILIADO`,
    RECORD_AUDIT: `Registo da auditoria`,
    RECORD_AUDIT_FOR: `Registo da auditoria para {dealer}`,
    RECORDS_FOUND: `{countToDisplay} {count, plural, one {registro encontrado} other {registros encontrados}}`,
    RECOVERABLE_TAXES: `Impostos Recuperáveis`,
    RECOVERED: `Recuperado`,
    RECOVERED_WITH_MISSED_ADDITIVES: `Recuperado com Aditivos em Falta`,
    RECOVERED_WITHOUT_ADDITIVES: `Recuperado sem Aditivos`,
    RECOVERY: `Recuperação`,
    RED_MUST_BE_LESS_THAN_YELLOW: `O valor do indicador vermelho deve ser inferior ao valor do indicador amarelo`,
    REFERENCE_1: `Referência 1`,
    REFERENCE_2: `Referência 2`,
    REFERENCE_INFORMATION: `Informações de Referência`,
    REFERENCE_NUMBER1: `Nº de Referência 1`,
    REFERENCE_NUMBER2: `Nº de Referência2`,
    REGION: `Região`,
    REGISTER: `Registrar`,
    REGISTER_A_PRODUCT_BY_PIN: `Registrar um produto pelo PIN`,
    REGISTER_A_PRODUCT_TO_ADD: `Registrar um Produto para Adicioná-lo ao sistema de Garantia`,
    REGISTER_ANOTHER_PRODUCT: `Registre outro Produto`,
    REGISTER_PRODUCT: `Registro do Produto`,
    REGISTER_PRODUCT_AND_REGISTER_ANOTHER: `Registrar um Produto e Outro`,
    REGISTERED: `Registrado`,
    REGISTRATION: `Registro`,
    REGISTRATION_DATE: `Data de Registro`,
    REGISTRATION_DATES: `Datas de Registros`,
    REGISTRATION_FORM: `Formulário de Registro`,
    REGISTRATION_HISTORY: `Histórico de Registros`,
    REGISTRATION_NOT_ALLOWED: `Registro não permitido para este produto`,
    REGISTRATION_REVIEW: `Análise de Registro`,
    REGISTRATION_REVIEW_TAB: `Análise de Registro ({count})`,
    REGISTRATION_STATUS: `Status do Registro`,
    REGISTRATION_STATUS_CANNOT_BE_NEW: `O Status do Registro não pode ser Novo`,
    REGISTRATION_STATUS_REQUIRED: `É necessário ter o Status do Registro`,
    REGISTRATION_SUCCESS: `Registro Bem-sucedido`,
    REGISTRATION_TYPE: `Tipo de Registro`,
    REGISTRATION_TYPE_CANNOT_BE_NEW: `Tipo de Registro não pode ser Novo`,
    REGISTRATION_TYPE_REQUIRED: `Tipo de Registro Obrigatório`,
    REGISTRATION_UPDATED_SUCCESSFULLY: `Registro Atualizado com sucesso`,
    REGISTRATIONS_REVIEW: `Análise de Registros`,
    REIMBURSED: `Reembolsado`,
    REIMBURSED_AMOUNT: `Montante do reembolso`,
    REIMBURSED_PERCENTAGE: `Percentagem do reembolso`,
    REIMBURSED_PERCENTAGE_INDICATOR: `Indicador de percentagem do reembolso`,
    REIMBURSEMENT_DETAILS: `Detalhes do reembolso`,
    REIMBURSEMENT_PERCENTAGE: `Percentagem do reembolso`,
    REIMBURSEMENT_SUMMARY: `Resumo do Reembolso`,
    REJECT: `Rejeitar`,
    REJECT_LABOR_RATE: `Rejeitar o Valor da mão de obra`,
    REJECT_SPECIAL_ALLOWANCE_CLAIM: `Rejeitar Solicitação de Concessão Especial`,
    REJECTED: `Reprovado`,
    REJECTED_APPEAL: `Apelo rejeitado`,
    RELATIONSHIP: `Relação`,
    RELATIONSHIP_IS_REQUIRED: `É necessária a relação`,
    REMOVE_FILTER: `Remover filtro`,
    REMOVE_FROM_AUDIT: `Remover da auditoria`,
    REMOVE_LAYOUT: `Remove Layout`,
    RENTAL_PINS: `PINs de aluguel`,
    REPAIR_DATE: `Data do Reparo`,
    REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: `A data do reparo não pode ser anterior à data da falha`,
    REPAIR_NUMBER: `Número de Reparo`,
    REPAIR_NUMBER_IS_REQUIRED: `É necessário o número da reparação`,
    REPAIR_REPLACE_INDICATOR: `Indicador de reparo/substituição`,
    REPAIRED: `Reparado`,
    REPAIRED_DATE: `Data da reparação`,
    REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: `A data do Reparo não pode ser anterior à data da Falha`,
    REPAIRED_DATE_IS_REQUIRED: `É necessária a data da reparação`,
    REPORT_DATE: `Data Relatada`,
    REPORT_NUMBER: `Número do Documento`,
    REPORTS: `Relatórios`,
    REQ_ADDL: `Ajuste de Crédito`,
    REQUEST: `Solicitação`,
    REQUEST_DATE: `Data de Requisição`,
    REQUEST_DETAILS: `Detalhes`,
    REQUEST_DUPLICATE_PIN_PLATE: `Solicitar Duplicação da Placa do PIN`,
    REQUEST_FORM: `Formulário de Solicitação`,
    REQUEST_PIP_CODE: `Código PIP de Solicitação`,
    REQUEST_STATUS: `Status da Solicitação`,
    REQUEST_SUBMITTED: `Pedido enviado`,
    REQUEST_TYPE: `Tipo de solicitação`,
    REQUEST_UPDATED_SUCCESSFULLY: `Solicitação atualizado`,
    REQUEST_WARRANTY_CLAIM_DEBIT: `Solicitar Débito de Solicitação de Garantia`,
    REQUESTED: `Solicitado`,
    REQUESTED_BY: `Solicitado por`,
    REQUESTED_DATE: `Data da solicitação`,
    REQUESTED_DATES: `Datas Solicitadas`,
    REQUESTED_DIAGNOSTIC_AMOUNT: `Quantia Desejada de Diagnóstico`,
    REQUESTED_DIAGNOSTIC_HOURS: `Horas de Diagnóstico Desejada`,
    REQUESTED_LABOR_AMOUNT: `Volume de mão de obra pedido`,
    REQUESTED_LABOR_HOURS: `Horas de Trabalho Solicitadas`,
    REQUESTED_OTHER_CREDITS: `Outros créditos pedidos`,
    REQUESTED_PARTS: `Peças Solicitadas`,
    REQUESTED_REPAIR_AMOUNT: `Quantia Desejada de Reparo`,
    REQUESTED_REPAIR_HOURS: `Horas de Reparo Desejada`,
    REQUESTED_TRAVEL_TOTAL: `Tempo total de deslocamento solicitado`,
    REQUESTER_TCSM: `Solicitante(TCSM)`,
    REQUESTER_TCSM_REQUIRED: `Solicitante (TCSM) Necessário`,
    REQUIRED: `Obrigatório`,
    REQUIRED_CRITERIA: `Critérios Obrigatórios`,
    REQUIRED_ITEMS: `Itens Obrigatórios`,
    RESEND_XML: `Reenviar XML`,
    RESET: `Redefinir`,
    RESPONDENT_INFORMATION: `Informações do inquirido`,
    RESPONSIBILITY_OF: `Responsabilidade de`,
    RESPONSIBLE_ACCOUNT: `Conta Responsável`,
    RESPONSIBLE_ACCOUNT_IS_REQUIRED: `É necessário ter a conta responsável`,
    RESPONSIBLE_DEALER: `Concessionário Responsável`,
    RESPONSIBLE_DEALER_REPORT_RECORDS_COUNT_WARNING: `Mostrando os primeiros 100 resultados. Faça o download para obter os resultados completos`,
    RET: `Devolução`,
    RETAIL_INSTALL: `Revenda/instalação`,
    RETAIL_INSTALL_DATE: `Venda/Data de Instalação`,
    RETAIL_INSTALL_IS_REQUIRED: `É necessária a revenda/instalação`,
    RETAILER_NAME: `Nome do Varejo`,
    RETAILER_NAME_IS_REQUIRED: `É necessário o nome do revendedor`,
    RETRY: `nova tentativa`,
    RETURN: `Devolução`,
    RETURN_LABOR_RATE: `Taxa de mão de obra de retorno`,
    RETURN_REQUEST: `Pedido de Devolução`,
    RETURN_SPECIAL_ALLOWANCE_CLAIM: `Devolver Solicitação de Concessão Especial`,
    RETURN_STATUS: `Status de Retorno`,
    RETURNED: `Retornado`,
    RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: `A data de devolução não pode ser anterior à data de entrega`,
    RETURNED_DATE_IS_REQUIRED: `É necessária a data de devolução`,
    RETURNED_MACHINE_STATUS_UPDATE: `Atualização do Status da Máquina Devolvida`,
    REVIEW_DEALER_RECOMMENDATIONS: `Tem certeza de que deseja marcar os PINs para Revisão?`,
    REVISE: `Revisar`,
    REVISED: `Revisado`,
    ROLLING_12_CREDIT_AMOUNT: `Prorrogação do Montante de 12 créditos`,
    ROLLING_12_MONTHS: `Prorrogação de 12 meses consecutivos`,
    RUN_REPORT: `Executar Relatório`,
    RUSSIAN: `Russo`,
    SAP_DOWN_WARNING: `A funcionalidade do Sistema de Garantia está prejudicada. Estamos trabalhando para corrigir isso o mais rápido possível. Atualize o navegador para verificar a disponibilidade do sistema.`,
    SAVE: `Salvar`,
    SAVE_AS_DRAFT: `Salvar como Rascunho`,
    SAVE_AS_NEW_LAYOUT: `Salvar como novo layout`,
    SAVE_AUDIT: `Salvar auditoria`,
    SAVE_CHANGES: `Salvar alterações`,
    SAVE_TO_VALIDATE: `Salvar para validar`,
    SAVE_VALD: `Salvar e Validar`,
    SAVE_VALIDATE: `Salvar e Validar`,
    SEARCH: `Pesquisar`,
    SEARCH_BOX_PLACEHOLDER: `Inserir PIN, Nº de Série, número de Solicitação, Caso do DTAC ou Nome do Cliente`,
    SEARCH_BY_CLAIM_TYPE: `Introduza o Tipo de Solicitação Completo`,
    SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: `A Pesquisa da Solicitação deve ser pelo Tipo de Solicitação com número completo, entre 4 e 9 Caracteres`,
    SEARCH_BY_FAILURE_PART_NUMBER: `Introduza o Número da Peça  Falha Completo`,
    SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: `A pesquisa da Solicitação deve ser pelo Tipo de Solicitação com número completo, no mínimo 4 caracteres`,
    SEARCH_BY_WORK_ORDER: `Introduza a ordem de serviço, no mínimo 2 caracteres`,
    SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: `A pesquisa da ordem de serviço deve ter no mínimo 2 caracteres`,
    SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: `Inserir o número completo da Solicitação`,
    SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: `A pesquisa de solicitação deve ser feita pelo número completo da solicitação, de 4 a 9 caracteres`,
    SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: `Insira o número de série completo do Componente`,
    SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: `A pesquisa de componentes deve ser efetuada através do número de série completo, pelo menos 1 caracter`,
    SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: `Inserir PIN`,
    SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: `Insira o número completo do Modelo`,
    SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: `A pesquisa pelo modelo deve ser feita pelo número completo do modelo, de 3 a 12 caracteres`,
    SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: `Introduza o PIN, no mínimo 6 caracteres`,
    SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: `A pesquisa do PIN deve ter entre 6 e 17 caracteres`,
    SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: `Insira o número PIP, no mínimo 4 caracteres`,
    SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: `A pesquisa pelo PIP deve ter de 4 a 12 caracteres`,
    SEARCH_RESULTS_TAB: `Resultados da Busca ({count})`,
    SECOND_SHIP_TO_LOCATION: `Segundo envio para o local`,
    SELECT: `Selecionar`,
    SELECT_A_RANGE: `Selecionar um intervalo`,
    SELECT_ALL: `Selecionar Tudo`,
    SELECT_AUTO_SUBMIT: `Selecionar Envio Automático`,
    SELECT_BRANCH: `Selecionar Filial`,
    SELECT_CLAIM_TYPE: `Selecione o tipo de Solicitação`,
    SELECT_CLAIMS: `Selecione Solicitações`,
    SELECT_CLAIMS_WITHIN_DATE_RANGE: `Selecione Solicitações para um período determinado`,
    SELECT_COLUMNS: `Selecione colunas`,
    SELECT_COUNTRY: `Selecionar País`,
    SELECT_CSV_SEPARATOR: `Selecionar CSV Separator`,
    SELECT_DATE_FORMAT: `Selecionar Formato da Data`,
    SELECT_DEALERS_AND_STATUS: `Selecionar Concessionários e Status`,
    SELECT_DECIMAL_FORMAT: `Selecionar Formato Decimal`,
    SELECT_DISPLAY_FORMAT: `Selecionar Formato de Exibição`,
    SELECT_FACTORY: `Selecionar Fábrica`,
    SELECT_LANGUAGE: `Selecionar Idioma`,
    SELECT_LAYOUT: `Selecionar Layout`,
    SELECT_NEW_CLAIMS: `Selecione Novas Solicitações `,
    SELECT_PIP_CODE: `Selecionar código PIP`,
    SELECT_PLAN_NAMES: `Selecionar Nomes do Plano`,
    SELECT_SERVICE_INTERVAL_TYPES: `Selecionar Tipos de Intervalo de Serviço`,
    SELECT_SORT_BY: `Selecionar Classificar por`,
    SELECT_SORT_DIRECTION: `Selecionar Ordenar Direção`,
    SELECT_STATE: `Selecionar Estado`,
    SELECT_STATUS: `Selecionar Status`,
    SELECT_TERRITORY: `Selecionar território`,
    SELECT_THEME: `Selecionar Tema`,
    SELECT_TIME_ZONE: `Selecionar Fuso-Horário`,
    SELECT_VALUES_TO_APPROVE: `Selecionar valores a aprovar`,
    SELECTED_COLUMNS: `Selecionada Colunas`,
    SELECTED_FOR_AUDIT: `Selecionado para Auditoria`,
    SELECTED_FOR_AUDIT_VSR: `Consulte a Solução DTAC 221475 para obter a documentação de auditoria e os anexos necessários para esta reclamação.`,
    SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: `Selecionar Diversas Contas & Tipos de Garantias que Afetam a performance.`,
    SEND: `Enviar`,
    SERIAL_NUMBER: `Número de Série`,
    SERIAL_NUMBER_INVOICE_NUMBER: `Número de Série / Número da Fatura`,
    SERVER_TOOK_TOO_LONG_TO_REPLY: `O Servidor demorou demais a responder e o pedido foi cancelado. Por Favor, tente uma Solicitação mais mais específica ou tente novamente mais tarde.`,
    SERVICE_DATE_IS_REQUIRED: `É necessária a data do serviço`,
    SERVICE_INTERVAL: `Intervalo de Serviço`,
    SERVICE_INTERVAL_BEGIN_DATE: `Data de Início do Intervalo de Serviços`,
    SERVICE_INTERVAL_END_DATE: `Data Final do Intervalo de Serviços`,
    SERVICE_INTERVAL_IS_REQUIRED: `É necessário o intervalo de manutenção`,
    SERVICE_INTERVAL_NUMBER: `Número do Intervalo de Serviços`,
    SERVICE_INTERVAL_STATUS: `Status do Intervalo de Serviço`,
    SERVICE_INTERVAL_TYPE: `Tipo de Intervalo de Serviço`,
    SERVICE_INTERVAL_TYPES: `Tipos de Intervalo de Serviço`,
    SERVICE_PART: `Parte de serviço`,
    SERVICE_UNAVAILABLE: `Serviço Indisponível`,
    SERVICED: `Submetido à Manutenção`,
    SERVICED_DATE_IS_REQUIRED: `É necessária a data do serviço`,
    SET_AS_DEFAULT: `Definir como padrão`,
    SETTINGS: `Minhas Configurações`,
    SETTLED: `Quitado`,
    SETTLEMENT_NO_REGISTRATION: `Acordo e Ausência de Registro`,
    SETUP: `Configuração`,
    SETUP_DATE_IS_REQUIRED: `É necessária a data de configuração`,
    SETUP_IS_REQUIRED: `É necessária a configuração`,
    SGST_UTGST: `SGST/UTGST`,
    SHIP_TO: `Enviado para`,
    SHIPPED: `Enviado`,
    SHIPPING_ID: `ID de Envio`,
    SHIPPING_ID_REQUIRED: `ID de Envio Necessária`,
    SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: `Informações de envio/instruções especiais`,
    SHIPPING_INSTRUCTIONS: `Instruções de Envio`,
    SHORT_TEXT: `Pequeno texto`,
    SHORT_TEXT_IS_REQUIRED: `Texto curto é obrigatório`,
    SHOW_ALL: `Mostrar tudo ({count})`,
    SHOW_EXCLUDED: `Mostrar Excluído`,
    SHOW_MORE: `Mostrar mais`,
    SHOW_MORE_GROUPS: `Mostrar {countToDisplay} mais {count, plural, one {grupo} other {grupos}}`,
    SHOW_RED_IF_LESS_THAN: `Mostrar Vermelho se Inferior a`,
    SHOW_REIMBURSED_AMOUNT: `Mostrar montante do reembolso`,
    SHOW_REIMBURSED_PERCENTAGE: `Mostrar percentagem do reembolso`,
    SHOW_YELLOW_IF_LESS_THAN: `Mostrar Amarelo se for Inferior a`,
    SIGN_IN_REQUIRED: `Login obrigatório`,
    SIGN_OUT: `Sair`,
    SKIP_AUDIT: `Ignorar Auditoria`,
    SKIP_AUDIT_SUCCESS: `A Auditoria foi ignorada e a data de vencimento está no futuro.`,
    SOME_PARTS_RETURNED: `Algumas Peças Devolvidas`,
    SORT_BY: `Classificar por`,
    SPANISH: `Espanhol`,
    SPECIAL_ALLOWANCE: `Cortesia/Solicitação de Concessão Especial`,
    SPECIAL_ALLOWANCE_CALCULATION: `Cálculo de solicitação de Concessão Especial`,
    SPECIAL_ALLOWANCE_CLAIM: `Solicitação de Concessão Especial`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS: `Status da Solicitação de Concessão Especial`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: `Status da Solicitação de Concessão Especial`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: `Status da Solicitação de Concessão Especial - atualizado`,
    SPECIAL_ALLOWANCE_CLAIM_WITH_ID: `Solicitação de Concessão Especial - {claimNumber}`,
    SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: `Solicitações de Concessões Especiais ({count})`,
    SPECIAL_ALLOWANCE_CONTRIBUTIONS: `Contribuições da Solicitação de Concessão Especial`,
    SPECIAL_ALLOWANCE_DESCRIPTION: `Descrição da solicitação de Concessão Especial`,
    SPECIAL_ALLOWANCE_TYPE: `Tipo de Concessão Espcial`,
    SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: `É necessário o Tipo de Solicitação de Concessão Especial`,
    SPECIAL_INSTRUCTIONS: `Instruções Especiais`,
    SPG: `SPG`,
    SPGS: `SPGs`,
    STANDARD_VIEW: `Visão geral`,
    START_AMOUNT_OF_USE: `Iniciar quantidade de Utilização`,
    STARTS: `Começar`,
    STARTS_WITH: `Começar com`,
    STATE: `Estado`,
    STATE_PROVINCE: `Estado/Província`,
    STATE_PROVINCE_REQUIRED: `Estado/Província Necessário`,
    STATUS: `Status`,
    STATUS_CHANGE_REQUEST: `Pedido de Mudança de Status`,
    STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: `Pedido de Alteração de Status Criado com Êxito`,
    STATUS_CHANGE_REQUEST_UPDATED_SUCCESSFULLY: `Solicitação de Status da Máquina atualizada com Êxito`,
    STATUS_FOR: `Status para {pin}`,
    STATUS_INDICATOR: `Indicador de Status`,
    STATUS_REASON: `Razão de Status`,
    STOLEN_DATE: `Data do Roubo`,
    STORE: `Loja`,
    STORE_IS_REQUIRED: `É necessária a loja`,
    STORE_NUMBER_IS_REQUIRED: `É necessário o número da loja`,
    STREET_1: `Endereço 1`,
    STREET_2: `Endereço 2`,
    SUB: `Enviar`,
    SUB_CLAIM_TYPE: `Tipo de Garantia Substituta`,
    SUB_TYPE: `Subtipo`,
    SUBMISSION_DATE: `Data de Transmissão`,
    SUBMIT: `Enviar/Submeter`,
    SUBMIT_AUDIT: `Enviar auditoria`,
    SUBMIT_AUDIT_FOR: `Enviar Auditoria para {dealer}`,
    SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Enviar Solicitação de Débito Completo para {claimNumber}`,
    SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Enviar reclamação de débito parcial para {claimNumber}`,
    SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Enviar Solicitação de Débito de Porcentagem para {claimNumber}`,
    SUBMIT_REQUEST: `Enviar pedido`,
    SUBMITTED: `Enviado`,
    SUBMITTED_AVAILABLE_TO_EDIT: `Enviado (Editável)`,
    SUCCESS: `Sucesso`,
    SUCCESS_MESSAGE_TITLE: `Uma operação foi efetuada com êxito:`,
    SUCCESS_MESSAGES_TITLE: `Várias operações foram efetuadas com êxito:`,
    SUPPLIER_WARRANTY: `Garantia do Fornecedor`,
    SURVEY_QUESTIONS: `Perguntas da Pesquisa`,
    SUSPENDED: `Suspendido`,
    SWEDISH: `Sueco`,
    SYSTEM_SELECTED_CLAIMS: `Reclamações selecionadas no sistema`,
    SYSTEM_SELECTED_CLAIMS_WITH_COUNT: `Solicitações Selecionadas no Sistema ({count})`,
    TABM: `TABM`,
    TAX: `Impostos`,
    TCSM: `TCSM`,
    TCSM_COMMENTS: `Comentários do Gerente Regional de Suporte ao Cliente`,
    TCSM_ID: `ID DO TCSM`,
    TECH_ID: `ID do Técnico`,
    TERMINATED: `Terminado`,
    TERMINATES: `Terminar`,
    TERRITORY: `Território`,
    TEST: `Teste`,
    TEST_RESULTS_CODE: `Código do Resultado do Teste`,
    THEME: `Tema`,
    TIME_LIMIT: `Prazo`,
    TIME_ZONE: `Fuso Horário`,
    TITLE: `Título`,
    TITLE_IS_REQUIRED: `Título é obrigatório`,
    TO: `Para`,
    TODAY: `Hoje`,
    TOO_MANY_RESULTS: `Sua solicitação retornou muitos resultados. Por favor, restrinja seus termos de pesquisa e tente novamente.`,
    TOTAL: `Total`,
    TOTAL_AMOUNT: `Total`,
    TOTAL_AMOUNT_IN_LOCAL_CURRENCY: `Total em PLN`,
    TOTAL_APPROVED: `Total Aprovado`,
    TOTAL_APPROVED_CLAIM_VALUE: `Total Valor Garantia aprovado`,
    TOTAL_APPROVED_INCLUDING_TAXES: `Total valor aprovado com Impostos`,
    TOTAL_APPROVED_WITHOUT_ADDITIVES: `Total Aprovado sem aditivos`,
    TOTAL_CONTRIBUTION: `Contribuição total`,
    TOTAL_REIMBURSED: `Reembolsado Totalmente`,
    TOTAL_REIMBURSED_WITH_CURRENCY: `Reembolso total ({currency})`,
    TOTAL_REQUESTED: `Total Solicitado`,
    TOTAL_REQUESTED_CLAIM_VALUE: ` Valor Total de Garantia Solicitado`,
    TOTAL_UNPAID: `Total Não Pago`,
    TRACKING_NUMBER: `Número de Rastreamento`,
    TRANSFER: `Transferir`,
    TRANSFER_ALL: `Transferir Tudo`,
    TRANSFER_APPROVALS: `Aprovações de Transferência`,
    TRANSFER_APPROVALS_TAB: `Aprovações de Transferência ({count})`,
    TRANSFER_CREATED: `Transferência Criada`,
    TRANSFER_DEALER_RECOMMENDATIONS: `Transferir Recomendações do Concessionário`,
    TRANSFER_REJECTED: `Transferência Rejeitada`,
    TRANSFER_UPDATED_SUCCESSFULLY: `Transferência atualizada com êxito`,
    TRANSFERALL_DEALER_RECOMMENDATIONS: `Transferir Todas as Recomendações do Concessionário`,
    TRANSFERS: `Transferências`,
    TRAVEL: `Deslocamento`,
    TURKISH: `Turco`,
    TWO_PERCENT_WITHHOLD_VALUE: `2% reter o valor`,
    TYPE: `Tipo`,
    TYPES: `Tipos`,
    UNABLE_TO_CONTACT_THE_SERVER: `Não foi possível entrar em contato com o servidor`,
    UNABLE_TO_COPY_ATTACHMENTS: `Não foi possível copiar anexos da solicitação original, revise antes de enviar sua nova solicitação.`,
    UNABLE_TO_LOAD_CUSTOMER_DETAILS: `Não foi possível carregar os detalhes do cliente`,
    UNDO: `Desfazer`,
    UNDO_REGISTRATION: `Desfazer Registro`,
    UNDO_REGISTRATION_SUCCESSFULL: `Registro de Desfazer Bem-sucedido`,
    UNIT: `Unidade`,
    UNIT_1: `Unidade 1`,
    UNIT_2: `Unidade 2`,
    UNIT_3: `Unidade 3`,
    UNIT_OF_MEASURE: `Unidade de Medida`,
    UNPAID_LABOR: `Mão de Obra Não Paga`,
    UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: `Complementos de mão de obra não pagos - Excluindo PIP`,
    UNPAID_LABOR_ADDITIVES_PIPS: `Complementos de mão de obra não pagos - PIP`,
    UNPAID_OTHER_CREDITS: `Outros Créditos não Pagos`,
    UNPAID_PARTS: `Peças Não Pagas`,
    UNPAID_PARTS_ADDITIVE: `O Aditivo de Peças não pagas`,
    UNPAID_TRAVEL: `Viagem não Paga`,
    UNRECONCIL: `Não Reconciliar`,
    UNRECONCILE_CLAIM : `Solicitação Não Reconciliada`,
    UNSUB: `Editar`,
    UNSUBMIT_CLAIM: `Editar Solicitação`,
    UPDATE: `Atualização`,
    UPDATE_CUSTOMER_INFORMATION: `Informação Nova do Cliente`,
    UPDATE_LABOR_RATES: `Atualizar taxas de mão de obra`,
    UPDATE_LAYOUT: `Layout de atualização`,
    UPDATE_MACHINE_STATUS: `Atualize o status da Máquina`,
    UPDATE_MACHINE_STATUS_HISTORY: `Atualizar Histórico de Status da Máquina`,
    UPDATE_REGISTRATION: `Atualizar Registro`,
    UPDATE_SELECTED: `Atualização Selecionada`,
    UPDATED: `Atualizado`,
    UPDATED_BY: `Atualizado por`,
    UPDATED_DATE_FROM: `Data Atualizada de`,
    UPDATED_DATE_TO: `Data Atualizada para`,
    UPLOAD_DOCUMENT: `Carregar documento`,
    UPTIME_ASSURANCE: `Garantia de Tempo de Atividade`,
    USEFUL_LINKS: `HiperLinkss Úteis`,
    USER: `usuário`,
    USER_PREFERENCES_UPDATED: `Preferências do usuário atualizadas`,
    USER_SELECTED: `Selecionado pelo utilizador`,
    USER_SELECTED_CLAIMS_WITH_COUNT: `Reclamações selecionadas pelo utilizador ({count})`,
    USERS_INFORMATION: `Informações do Usuário`,
    VALIDATE: `Validar`,
    VALIDATE_CLAIM: `Validar Solicitação`,
    VALUE: `Valor`,
    VALUE_OF_REPAIR: `Valor da reparação`,
    VIEW_CLAIM: `Ver Solicitação`,
    VIEW_DETAILS: `Exibir detalhes`,
    VIEW_OPEN_PIPS: `Visualizar PIPs Abertos`,
    VIEW_PIP: `Exibir PIP`,
    VIEW_PRODUCTS: `Visualizar Produtos`,
    VIEW_PRODUCTS_AND_UPDATE_INFO: `Ver produtos e Atualizar informação`,
    VIEW_UPDATE: `Ver/atualizar`,
    VSR_MESSAGES: `Mensagens VSR`,
    WAITING_FOR_DLR_INV: `Esperando Fatura do Concessionário`,
    WAITING_FOR_INVOICE: `A Aguardar Fatura ({count})`,
    WAITING_SINCE: `Aguardando Desde`,
    WARNING_MESSAGE_TITLE: `Foi enviada uma advertência:`,
    WARNING_MESSAGES: `Mensagens de advertência`,
    WARNING_MESSAGES_TITLE: `Foram enviadas várias advertências:`,
    WARRANTY: `Garantias`,
    WARRANTY_ADMIN: `Admin de Garantia`,
    WARRANTY_CLAIM_TYPE: `Tipo de Reclamação de Garantia`,
    WARRANTY_COVERAGE: `Cobertura da Garantia`,
    WARRANTY_EXPIRATION: `Término da Garantia`,
    WARRANTY_TYPE: `Tipo de Garantia`,
    WARRANTY_TYPES: `Tipos de Garantias`,
    WEAR_PARTS: `Peças de Desgaste`,
    WEAR_PARTS_COVERAGE: `Cobertura de Peças de Desgaste`,
    WELCOME: `Bem Vindo`,
    WINTERIZATION: `Preparação para o inverno`,
    WIP: `Trabalho em andamento`,
    WITH_ADDITIVES: `Com Complementos/Aditivos`,
    WITNESS_FIRST_NAME: `Nome da Testemunha`,
    WITNESS_LAST_NAME: `Sobrenome da Testemunha`,
    WORK_ORDER: `Ordem de Trabalho`,
    WORK_ORDER_NUMBER: `Número da ordem de serviço`,
    WORK_ORDER_ONE: `Ordem de Serviço 1`,
    WORK_ORDER_ONE_IS_REQUIRED: `É necessária a ordem de serviço 1`,
    WORK_ORDER_THREE: `Ordem de serviço 3`,
    WORK_ORDER_THREE_IS_REQUIRED: `É necessária a ordem de serviço 3`,
    WORK_ORDER_TWO: `Ordem de Serviço 2`,
    WORK_REPAIR_ORDER: `Ordem de serviço de reparação`,
    YES: `Sim`,
    YES_LOWERCASE: `Sim`
});



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-i18n/lib/pt.js